import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { EAlertButtonCodes, EClass } from 'src/app/classes/def/app/ui';
import { IChatElement } from 'src/app/classes/def/mp/chat';
import { Platform } from '@ionic/angular';
import { KeyboardProvider } from 'src/app/services/apis/keyboard';
import { GeneralCache } from 'src/app/classes/app/general-cache';
import { ThemeColors } from 'src/app/classes/def/app/theme';
import { IUserStatsChangedResult } from 'src/app/classes/def/user/stats';
import { IUpdatingAppNavParms } from 'src/app/classes/def/app/liveupdate';
import { INavParams, IViewSpecs, ViewSpecs } from 'src/app/classes/def/nav-params/general';
import { UpdatingAppViewComponent } from 'src/app/modals/app/modals/updating-app/updating-app.component';
import { IGameItem, EItemCategoryCodes } from 'src/app/classes/def/items/game-item';
import { LoginPage } from '../logins/login/login.page';
import { IShareMsgParams } from 'src/app/classes/utils/message-utils';
import { AchievementUnlockedViewComponent } from 'src/app/modals/app/modals/achievement-unlocked/achievement-unlocked.component';
import { EAchievementUnlockedParams } from 'src/app/classes/def/nav-params/achievement';
import { IInventoryNavParams } from 'src/app/classes/def/nav-params/inventory';
import { IPhotoValidatorParams, EPhotoValidatorModes } from 'src/app/classes/def/media/photo-validator';
import { IPhotoResultResponse } from 'src/app/classes/def/media/processing';
import { IActivityParamsView, EActivityParamsViewModes } from 'src/app/classes/def/nav-params/activity-details';
import { ECustomParamScope } from 'src/app/classes/def/core/custom-param';
import { ActivityParamsViewComponent } from 'src/app/modals/app/modals/activity-params-vc/activity-params-vc.component';
import { IImageCropFrameNavParams, ImageCropFrameViewComponent } from 'src/app/modals/generic/modals/image-crop-frame/image-crop-frame.component';
import { IActivityFailed, IArenaNavParams, IItemFound } from 'src/app/classes/def/nav-params/activity';
import { EStandardActivityFailedCode, IActivityStatsContainer, EActivityCodes } from 'src/app/classes/def/core/activity';
import { ActivityFailedViewComponent } from 'src/app/modals/app/modals/activity-failed/activity-failed.component';
import { EGameContext } from 'src/app/classes/def/core/game';
import { ActivityFinishedViewComponent } from 'src/app/modals/app/modals/activity-finished/activity-finished.component';
import { ARViewEntryPage } from '../ar-view-entry/ar-view-entry.page';
import { EStoryLocationDoneFlag, IStoryListNavParams } from 'src/app/classes/def/nav-params/story';
import { ITextInputParams, ITextInputResult, TextInputViewComponent } from 'src/app/modals/generic/modals/text-input/text-input.component';
import { IMPGameResultPlayer, EMPGameResultVerdict, IMPGameResults } from 'src/app/classes/def/mp/http';
import { IEventLeaderboard } from 'src/app/classes/def/events/events';
import { EGroupContext, IGroupMember } from 'src/app/classes/def/mp/groups';
import { ILeaderboardNavParams, ELeaderboardScope } from 'src/app/classes/def/nav-params/leaderboard';
import { LeaderboardPage } from '../leaderboard/leaderboard.page';
import { StoryFinishedViewComponent } from 'src/app/modals/app/modals/story-finished/story-finished.component';
import { ResourceManager } from 'src/app/classes/general/resource-manager';
import { SettingsManagerService } from 'src/app/services/general/settings-manager';
import { ResourcesCoreDataService } from 'src/app/services/data/resources-core';
import { BackButtonService } from 'src/app/services/general/ui/back-button';
import { AdsService } from 'src/app/services/general/apis/ads';
import { LocalNotificationsService } from 'src/app/services/general/apis/local-notifications';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import { UserStatsDataService } from 'src/app/services/data/user-stats';
import { InventoryDataService } from 'src/app/services/data/inventory';
import { PhotoValidatorService } from 'src/app/services/app/utils/photo-validator';
import { YouTubeService } from 'src/app/services/general/apis/youtube';
import { ChallengeEntryService } from 'src/app/services/app/modules/challenge-entry';
import { PhotoViewService } from 'src/app/services/general/apis/photo-view';
import { PhotosService } from 'src/app/services/media/photos';
import { ScreenshotService } from 'src/app/services/media/screenshot';
import { AchievementsDataService } from 'src/app/services/data/achievements';
import { MessageQueueHandlerService } from 'src/app/services/general/message-queue-handler';
import { ContentCreatorService } from 'src/app/services/app/modules/content-creator';
import { ActivityStatsService } from 'src/app/services/app/modules/activity-stats';
import { MPGameInterfaceService } from 'src/app/services/app/mp/mp-game-interface';
import { PopupFeaturesService } from 'src/app/services/app/modules/minor/popup-features';
import { RewardModalsService } from 'src/app/services/app/modules/minor/reward-modals';
import { TutorialsService } from 'src/app/services/app/modules/minor/tutorials';
import { MediaUtilsService } from 'src/app/services/media/media-utils';
import { ImageLoaderTSService } from 'src/app/services/media/image-loader-ts';
import { SoundValidatorService } from 'src/app/services/app/utils/sound-validator';
import { DanceAccActivityService } from 'src/app/services/app/modules/activities/danceAcc';
import { DecibelActivityService } from 'src/app/services/app/modules/activities/decibel';
import { GenericDataService } from 'src/app/services/general/data/generic';
import { ERouteDef } from 'src/app/app-utils';
import { StoryCategoriesPage } from '../storyline/story-categories/story-categories.page';
import { MPHomePage } from '../mp/mp-home/mp-home.page';
import { InventoryHomePage } from '../inventory/inventory-home/inventory-home.page';
import { NavParamsService } from 'src/app/services/app/nav-params';
import { PlacesDataService } from 'src/app/services/data/places';
import { ILeplaceTreasure } from 'src/app/classes/def/places/leplace';
import { ITreasureFoundReturnData } from 'src/app/classes/def/nav-params/modal-finished-return';
import { ModularViewsService } from 'src/app/services/utils/modular-views';
import { LocationUtilsGooglePlus } from 'src/app/services/location/location-utils-google-plus';
import { ITTSVoice, TextToSpeechService } from 'src/app/services/general/apis/tts';
import { INgxChartOptions } from 'src/app/classes/def/app/charts';
import { NgxChartParams } from 'src/app/classes/general/params';
import { IGmapEntryNavParams, EGmapMode } from 'src/app/classes/def/nav-params/gmap';
import { ENavParamsResources } from 'src/app/classes/def/nav-params/resources';
import { SoundEffectsService } from 'src/app/services/general/apis/sound-effects';
import { SoundManagerService } from 'src/app/services/general/apis/sound-manager';
import { ILocationPhotoResult } from 'src/app/services/location/location-utils-def';
import { EDescriptionViewStyle, IDescriptionFrameParams } from 'src/app/modals/generic/modals/description-frame/description-frame.component';
import { Router } from '@angular/router';
import { StoryDataService } from 'src/app/services/data/story';
import { IGenericSlideData } from 'src/app/classes/def/views/slides';
import { ZoomService } from 'src/app/services/general/apis/zoom';
import { SoundUtils } from 'src/app/services/general/apis/sound-utils';
import { ETutorialEntries } from 'src/app/classes/def/app/tutorials';
import { SleepUtils } from 'src/app/services/utils/sleep-utils';
import { IndoorLocationManagerService } from 'src/app/services/map/indoor-location-manager';
import { BeaconScannerViewComponent } from 'src/app/modals/app/modals/beacon-scanner/beacon-scanner.component';
import { IBeaconScannerParams } from 'src/app/modals/app/modals/beacon-scanner/def';
import { PromiseUtils } from 'src/app/services/utils/promise-utils';
import { AvRecordingFrameComponent, IAVFrameNavParams } from 'src/app/modals/generic/modals/av-recording-frame/av-recording-frame.component';
import { VideoService } from 'src/app/services/media/video';
import { AudioRecordingFrameComponent, IAudioFrameNavParams } from 'src/app/modals/generic/modals/audio-recording-frame/audio-recording-frame.component';
import { AudioService } from 'src/app/services/media/audio';
import { ApiDef } from 'src/app/classes/app/api';
import { EQueueMessageCode } from 'src/app/classes/utils/queue';
import { MQTTChatService } from 'src/app/services/telemetry/chat.service';
import { PermissionsService } from 'src/app/services/general/permissions/permissions';
import { IScanQRResultString, QRService } from 'src/app/services/general/apis/qr';
import { Messages } from 'src/app/classes/def/app/messages';
import { Util } from 'src/app/classes/general/util';
import { WebviewUtilsService } from 'src/app/services/app/utils/webview-utils';
import { CrashlyticsService } from 'src/app/services/general/apis/crashlytics';
import { ErrorMessage } from 'src/app/classes/general/error-message';
import { ShareService } from 'src/app/services/general/apis/share';
import { IPhotoFrameNavParams, PhotoFrameViewComponent } from 'src/app/modals/generic/modals/photo-frame/photo-frame.component';
import { EAppIcons, EAppIconsStandard, EPhotos } from 'src/app/classes/def/app/icons';

@Component({
  selector: 'app-test',
  templateUrl: './test.page.html',
  styleUrls: ['./test.page.scss'],
  animations: [
    trigger('showState', [
      state('inactive', style({
        opacity: 0
      })),
      state('active', style({
        opacity: 1
      })),
      transition('inactive => active', animate('0.25s ease-in')),
      transition('active => inactive', animate('0.25s ease-out'))
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class TestPage implements OnInit, OnDestroy {
  settings: any;
  description: string = null;
  loaded: boolean = false;
  showState: string = 'active';

  theme: string = "theme-light theme-light-bg";
  version: string;

  subscription = {
    watchReward: null,
    soundChalllengeStatus: null,
    soundAmp: null
  };

  timeouts = {

  };

  appIconsStandard = EAppIconsStandard;
  appIcons = EAppIcons;

  hudClass = EClass.HUD_BAN_NORMAL;
  testHUD: boolean = false;

  chatRx: IChatElement[] = [];
  chatTx: string = "";
  chatUserId: number = 2;

  testInput: string = "";

  toggle: boolean = false;

  np: INavParams = null;
  vs: IViewSpecs;
  testAA: number = null;

  chartOptions: INgxChartOptions = NgxChartParams.getVGaugeOptions();

  // this.testAnimate.state == 'inactive' ? this.testAnimate.state = 'active' : this.testAnimate.state = 'inactive'

  constructor(
    public settingsProvider: SettingsManagerService,
    public plt: Platform,
    public webView: WebviewUtilsService,
    public router: Router,
    public resourcesProvider: ResourcesCoreDataService,
    public backButton: BackButtonService,
    private adService: AdsService,
    private localNotifications: LocalNotificationsService,
    private uiext: UiExtensionService,
    public userStatsProvider: UserStatsDataService,
    public inventory: InventoryDataService,
    public photoValidator: PhotoValidatorService,
    public keyboard: KeyboardProvider,
    public ytp: YouTubeService,
    public soundChallenge: SoundValidatorService,
    public challengeEntry: ChallengeEntryService,
    public photoViewer: PhotoViewService,
    public photos: PhotosService,
    public screenshot: ScreenshotService,
    public dance: DanceAccActivityService,
    public dbm: DecibelActivityService,
    public achievements: AchievementsDataService,
    public messageQ: MessageQueueHandlerService,
    public contentCreator: ContentCreatorService,
    public activityStats: ActivityStatsService,
    public mpGameInterface: MPGameInterfaceService,
    public popupFeatures: PopupFeaturesService,
    public rewardModals: RewardModalsService,
    public tutorials: TutorialsService,
    public generic: GenericDataService,
    public imageLoaderTS: ImageLoaderTSService,
    public mediaUtils: MediaUtilsService,
    public nps: NavParamsService,
    public placesData: PlacesDataService,
    public modularViews: ModularViewsService,
    public locationUtilsGooglePlus: LocationUtilsGooglePlus,
    public tts: TextToSpeechService,
    public soundEffects: SoundEffectsService,
    public soundManager: SoundManagerService,
    public storyData: StoryDataService,
    public zoomService: ZoomService,
    public indoorLocation: IndoorLocationManagerService,
    public video: VideoService,
    public audio: AudioService,
    public mqttChatService: MQTTChatService,
    public permissions: PermissionsService,
    public qrSecurity: QRService,
    public crashlytics: CrashlyticsService,
    public share: ShareService
  ) {

  }

  getHeaderClass() {
    return ViewSpecs.getHeaderClass(this.vs, false);
  }

  ngOnInit() {
    this.loaded = true;
    this.version = GeneralCache.versionString;
    this.settingsProvider.getSettingsLoaded(false).then((res) => {
      if (res) {
        // ThemeClass[Settings.settings.app.settings.theme.value]
        this.theme = ThemeColors.theme[SettingsManagerService.settings.app.settings.theme.value].css;
        this.settings = this.settingsProvider.getSettings();
      }
    }).catch((err: Error) => {
      console.error(err);
    });

    this.adService.checkSettings();

    this.webView.ready().then(() => {
      this.backButton.replace(() => {
        this.back();
      });
    }).catch((err: Error) => { console.error(err); });
  }

  swipeEvent(e) {
    this.backButton.handleSwipeEvent(e);
  }

  back() {
    this.router.navigate([ERouteDef.settings], { replaceUrl: true }).then(() => {
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  testAddCustomTreasure() {
    this.contentCreator.placeContent(null, null, false, false, null, null).then(() => {

    }).catch((err: Error) => {
      console.error(err);
    });
  }

  takePhoto(fromGallery: boolean) {
    PromiseUtils.wrapNoAction(this.photos.takePhotoWrapper(fromGallery), true);
  }

  testCrash() {
    this.crashlytics.crash();
  }

  testShare() {
    PromiseUtils.wrapNoAction(this.share.share("test"), true);
  }

  viewPhoto() {
    // console.log("view photo");

    let params: IPhotoFrameNavParams = {
      photoUrl: `data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCADwAUADASIAAhEBAxEB/8QAHQAAAgMBAQEBAQAAAAAAAAAABgcDBAUIAgkBAP/EAEkQAAIBAwMDAgQDBQUGAwYHAQECAwQFEQYSIQAHMRNBCCJRYRQycRUjQoGRFiQzUqEJQ2JyscFTgtEXJZKi0uEmNERUssLw8f/EABsBAAIDAQEBAAAAAAAAAAAAAAMEAQIFBgAH/8QAPREAAQMCAwUHAgUDAwMFAAAAAQACAxEhBBIxBUFRYfATInGBobHBkdEGFDLh8RUjQiRygjNSYgcWc6LS/9oADAMBAAIRAxEAPwD6gXmw2jUNuqLTeaCGrpKpDHLFIuQw/wCxHkEcggEcjriLux2X1p8I96re/HaWpe7aAkrI59c6OWLCvSHCyXKBQMRzJnc+zCnBfAVnUd0CphP8YB+nX9U01PW08tLVU8U8MyNHJHIgZHRhgqwPBBBIIPserhzmqa7lx7qPtho3vhoSi7ndq6z1rPqJHrIahKdoTOwYoxkjb+MMhGSM8ecHpRaZ+Gi+3XVBs/qt/dXBraiXPqxxt8yqsZGwZA4xjOPm6cPwzGH4f+/PcH4QK2MxWKt9TW+hZJclPwM+BU0oJ/8ACkBx9kc+/R9o5qmG/wDcO7MBEs2qZoQ2P91TU0UfH2yGPXRbP27iYI+yYdOuqpDEYCGV2dwXzq7u/DzXdr/ie7b9pL3R/tvt1qu9Q3WhtzutLG8xlU1dIrDJXLKMJwD66gYJLD6N627gdoP7H3/Wtw1VYbVpS2GGj/HvL6Zas9PdLAF8+qm6KP0VXerh1IBUgcV/Gh307cd8F0jo/suly1VrXSV4k1DBc7ZQvLT0UUEReUk7SZFxGkpZRtX0gG+Y7RpfDB2I0h8VNZaO7ffvu9Udx57nJWS09pBanpKW5xbS8FWihS2+BBIojEYkjjfJYL1iyYl4mL4zevktBkQ7MBy5i7has1R8R/xD0917F0N+tCUtvFnhuCK0c8VGu8zVEzRkiIEM4AyCRhckk9NnS+kNM9s7TVUlv05NVXOrJSovNy/ezVBxgkbuIxyflH1ySTz19Du39p7Z9r9I0Pbe2aAtml2k/EC0UlA6GhvTpli8VQNwLvkZEu1tzcA562bd297XX+wQaktNuo6+nqnepjlMW4Z5Vsg+CCCp+hBHW5sfaeFwshmxDM7ybHh4fdZ2NwsszAyN2VvuvnPpGyLHXQ1lykpo4HrHmT04MRqC5b0wM4wCffzk/bBP3MtulaRwtqt0kU4cqZxwrsAMjHjH0+nXSncK1dubpJrDTDUkVXPabdTXiiWBCDTGVHiCFgAsW6WJSoY/N6jfbrnzXnau9afq6ikWs9eIsojSRirySheQq85PDYAOcddzsra2HxThQlmXcT8lc9jcFLA24Dq7wEso4iRuCk4GTx4HU0aYHPv1SoJTM0NzM7SR1TulHGJAIxEqPvlzzlnIA+yhRjOT1/U01XeJWSmkEFHCRHNNGwLzSgDeiH+FVzgv5JyBjGeughxZkcW5d/doa1Fr8tfpzssaaClHV8eSnrauZQ9vtbj9pSRkx+dsGeBI5x8oHkDyxGAPJGjRpcck11RBJlQAEiIO73YsTzn9B56q2qKlt6PbEZQacCQlj8zI2cOxPJOQwLHyR17jqLvVXOQWwUstDFGYWMjEf3kPztKqSyqPlOCBnxyDi+VhkEj7vsKAmwB30NwDru5Id8pY39PE7/stSIYOOrUYx1mrVQW+GOG5XaKaobJ+VAGY8/KiLk44OByeOT1qBCjY+wP+nTcM7JhY3vataUNNyXkjdHrpxU8S5PV6HAHVGMnx1eiyOOmghK2mMDHU8YHVaM9Tofr14KFbjxjqzGR1RU4/l1ajJ6tRQbLSgIHt1aRwcdZsbe2erULe2eqkVsUMkhaETZ89Tr1TRseOrMbBvHS72qarQpl3Edb1viXIY+B1iUang9a8c3ppgHrPxFTYI0drrXeoB+UeB56iNQu7dkdZn4gkY9+v71SfJz0n2NEwZQtU1AA/Nnr+WYHkcnrKEn0PU0U23yeoMQooElTda61A8fXqzBKGPPgdYsc5JOTx7dXKeTHk9AfFREDg5a7zhVxkc9J7v3bazUtJbbNadOQXCtkqViSaSYq0CuCSwUEAr8mGJzjj69MuSpO76joT1hKErIW3NmeHZ6cQxLNhvyB/4F5yx+nWdj4qYcg701s54GIBGqRtV211RQz3O61FZSLQWVo41qYRj8S3ykiJfGE5z91I89CNZK0tZUQUZfY7erLPMuxnBOd78fKuTnb/ANTjp16jkrLpZqqOP0AI4mjhk2n8NA4GVjiUY3sSME//APAhpmutWu65TRrGuGeYIURjjyRklm9h+ntz1yTomwy0bvC6SSR0kVTuKtxVFIkTJBkmIrKZWGCxB5AHsuCfv9fp1c9eKlmZaIGSoZt3qFeIs8gKPc8/mP8AL69ZtPP68hoaGORYpEIkOBucYPLHwADjjx+p6sU9zZKeB6eLE06Y9QctxxhR7H7+fpjqpNHpcDM1fVXS+oZLzFUx3GmWnraGrmo5ljLFNyN8rIxA3KyFG+24g8jrcjvpWT085C8HrkOw94Na1XxDXrRVDfrEmnBDJcUiSXdWzVLwRZiCkbo3jILupOMHwOhL4iPiB7j6Y1xb+2+krwbdDWWOe8V1TDTu9Usq1KJAUZCGwTuDKAdwHWBBH+YBpuJH0+q6OaVsQqfFEPx/3WPtv3a+Hrv9S1Ro47Vqh7FdKrjaKKoCM6tkgY2CfzxyelDfu7/c/wCIvU9z+Hb4YZZaazT3e4T6q1vG7vFFTSTycJKowkbIoUFTvmPClVyTyp8SvxDd0++lztPbKt1fPqG22WqMsSSfuklrGUo0jFwCBGuVyxwMufv11H8MneXUPw79o6PRGl9OWK8JGjVFfTUroaiuqmbLSGQPy20KoBOFVQAAc5GIXlzmsu0a03+Ct27Gsa99q8ea6M7LdhO2nwt6XvVVoejqayuktrRXCsryjTVppxK5Zjj5FctzGDswq8Egk8bdqNFJ2l+K9ez9l1fU2STWFpturdIVcUyg2+6PEahaSQEFGifFRTnK/kZWHOQzW7kfH1oPT2jb5p/UNqRbxX0VRDDT2+r9aeNpg2RIhGIyNx8sMHHHHXIna3vxq7WnxPVfe+j0dNcr5R238Jp6zQU0lYacCFaSmVETBdkQk84BZmY4x0SYMa0A+imOQvdVpX1Q0v3T0jo60XfUXcNDbdM11OaQ1V1thT9l/hRMai21rKphVldnEYUhZGO1VBZA3NGlP9ozae1l+nt2q9EpT9rb1WPU2SmS4CovtupKhvUDvEMh0kLPP6cjrIiybQWwAEX3O7SfFJ3fnqdTd7K+p0hR1FXFLJb23zSUw2CJZ6qjgwixblgVpSS8ShWYbQxFLsn8Lti0z3MXRnfewWipitmso6O5XiG8OY692SMR0VMmNrCOaSKSoYEShJdmF2uOoMEgocpCtnaSb1Tb1J8UWr+8d1iuPw2fDZrC+GW/vUNcrlFi3V4LBqajaMD0wq/hqeQfvgfUgPGGI6Ufd3XPxXdyL3Po3vndB20pqtS9PAluEENbUK64pzPExOTuQgs+05Geu8e6Vq7Oaf07YbnZ7RQUlrtNypa+oqqC4zUc0VF+8QyRVCNuQRyyRyFeOI3Hngr3tRrTSCR6kTV1llrWuN1mpVrLxTBqq5UyxIiNUCTcwDDkRn5Qc4HWlhcHipzkBNxz09K/VLTTQsGY7uuaQ+gfhS1cmjZbL291/qCiusNNLUmO7xRx0E7OwGI4TvePd4EygMCAzDnAo1do1D29ttosutdK3bRsf4tqD1Uov2jT5UDZsmilLTvI2eAgbksx8k9Aal0Tc+1tqm1X2tuDT6HuNP8AvrB6oeosUq5/eUJc5kgbOWpi6lSAY+Mr0ndH6005qSoumtNf2xb5I9xrIKWqq2khelUOoCoj4ELDapK7ckgE5yOujwmFnlb2WDcYnUII3UFiQSKHdWhB0zblkYiWKM55wHjcd/Kt/uNaIOtK1Wtp6+WKvEUFEZKIwei8NaoVgfWmhY5CnypI24bk7hgEkNliWGOnlq6iWnjXasAdY4sfTbGFyPsSR1n3CnptT1URoaCZUgZnguz7oJoGB4MBGHZvvwn/ADeOoqOe56XrpodUahr7p+0ZyluqaqWJUZzjbBKAqhJMjCyZ2vkghWxu7DDk7PJkxQzMOslTT/k0kgDm3u1uQFgSgYruwHK4f4UFfIjU8jfxRLRU1NQxiCjp4qeNRgJEgQf0HV1AT46rwRybF9V0eQcMUGFJHnA9v59XIx/p10zGjKKaLFcSXGq9xjBGPPVyLOOfr1BGnOcdW0QhQWKqCcAk4yfoM+/UuIYKuNFXXRTRnqVPPUaKRx1KikdeAuoBUydWk6rIpJx1ZQHq6hxU6EgZ6sxMcg9V484x1Opx14oZNbK4hOOrcHVKEkgH69X6dffoElgpatSkO1R9erHrE+D1RWTA4Pnr0JD9eknMqaogcQrokzz17EnVNZfqepFkB8HoZYpzK0H+h6lV+OqinPv1Kr9CLVYOVpG5BBx1bWcKg55PWejdSbvv0FzVcFWTMW8Z6yNQ0L3FqaNaeqqPlkVoYBgSDK/K7fwJzy38uc4OgjZPnqaOL8RW0cDW+auEzyQtTx1X4cSBo24d/wDw+MsOcgeD4OftJv8ApXU6uj4A/wCrbXqyBa+CKGmjqVnQRU7ek1UB+5ibBBhpk/3jePm+v1/KOdr3a4KWeoSWCemSlrJInkd9zN/lQJnhsAk54589dPasMUdCbjRtDKVdadriI9tJTb8r6VLFzvPGC/Ofq35RzX3Dt60Oo7i9XbZl3xx1W6WfE20gZJBzksR9yB/Trh8U79DufuuxDO65vL2WSJnmX06ULDBCQ75b5QR4Z29z/wD4Dqalq5E9WOnOClQUVkU79jcjb7jPH36xY56iuTcTHTUcJwvkRofoPJZj/MnqenmkNRPDQSTH1qZNmOHcqdrDj6gePv0vJYgpdhqCF19PdrZR9+rDXUempVrb1S1lDVtPTenW0lR6Cyemwwd6SJSKyOrFGMcoDH5scqfG1rhrd3Q1rUUcs63SntVq04iLt2wK4eokbPO8kNgrjgleSfHb/wAQfbjSVi0fTd0dSSVc1Fp+6W6tqbzAx/G0MLzx0800FVFgpGsUrM0YVkO3O3lg3y97w6stOvO+OoL0bomobbVXSRqq40kHoGrpoSse9AeIhIkSnGCFLNj5fGDPOGNc2uvRXSiLORy+F67RaZj0hp5de3eJo666LvgkmDxiCkyMlXyh3uu4gKxDAKCRnq1qrWlr1tZ6o0GtIqG2LGyyPToZKuaQ/lT97ukiO8YwjEtnzjoSqO4GpdUagh03o20L6qv+GpKeMJFBsBIWSRVCoNoIHqEeR555Me2fZwaYvFdX3Yfj7xbaiN6xFSOSJDJAHwgUyIWBLcspyBwqkjqzXve3JEcrBqTTzQHMa12eQVdw9kAaQ+H29XGBLnreqa000h9T8K22OrY5/LIJmQR5HuNx58dMbQNLeexGuNW90u21xmo4dCPbqe52uWeSUV1HUOi1EDS42/mUMuTz5HKY6Ia7Xgju8WmNFUi3q4u0e8Qz+hSRKzY/eTRiHYfGAU5yPc46t9jezd5703PuRe9TX2OhgkvTUS2aCQtSVNyXJQuWIWRVG5FJBI9QsPGCzNEwsLYRmd8+OiFFK8OzSmg63L6WXnvB287r6QtFv7X1tJcb93GoainpI6tUdbZSOvp1FTVjkKsayfLETuldkUDBZlTWqdKaE0P8PzaZuF4qbpVW/UV50pZrelPG9yvk1NXTQxRRRxqu+coFMlQRwxd3bwOi+26o7HdtO2Fz0pc7pfa7SlqtrX23UNbVCquFlZYzMRS1K4lDhjhV3HYRgNsOOrvwlaK0ro7SNB3R7iXJtTdyNTJLdKy410gnNtWrkaf8NSrykAPqBpTHj1JCxJICgRFHjsJI1+U5qbxu+yYc/DzMLa2r6pMaY+FjurrSxw0ty0d+ybw9velNw1NUrHS05eIqxjtdK0rOwJDB3khwyhgiglDDqL4c/iH00Va/3mXVjiSoqTJRU0EIgaUs8ggX0wUUseMnO3Kk/wAXXb1b3J0dYKhau536jpqhyAKZpMysCcACJcuc+BheshdWXXV93S7VcT2exwEmnpJEKV1U3IElQD/gx4yVi/OSVL7NuwtRTTMkBAPkSKHjb51Qnhjm3Sck+Fa86i0N+Ft2r9Q0kLxRyxwz3CjqmaXaoMiskBCo2CdnqMOePPHP3cP4Ve4Pb/T9X3HrorZPDaZo5bo1fUCpzR71V5sYVUeIFXDJtO1WByMDrqfW/cFdHXiK3aNlqJjV1Ik/BVfq09Hn5mlkSrUMseNuTGylWZhtC7mPQX3V7q3zWPbKu0pUWuW3U9xr7fS3S61lxovw9LQtWReo+VlYyAhQuNo+Vjn6daseNx2Hwr3UzAGveBq0i9Qa28dacki+DDyyjcTa1BUcCEk9Rdoe4NhmqlnS0MtNSrUGSlrEq2fj58AMMlMqSvOVdWBIJwFmw0E8E0FxphW/iUMdQapRJ6inypB4C/8ACAAP156+g9BovS0mgJbTbrZb7pIWUmZoFheUBy6tvjII2szFdhUKDtAA8pfu18PYs2lK/Vlllq5RJJ+IWGGkRjAmPmjaRf3hG4n5xyAAMHz11GxvxOZ/7OPZVzjQU57iCfXesPH7IEffwzqAC/8AIXJMtRW6YroIqy6+tpySVYnq6iQtJbplPyxSyeXifIUO/KEAMxVgVM44OceCOq9fpK5Wa3G26k0y0ltuiepFEgaT1o2OWZi5HqK3GQOc5yDu4HLLPfbRcTYbHbay5WSHZPSLPG1NUU0QOJKZGm2rKiErjdtKqdoZ8DHQQzN2WbNJjebAVJadLDezSlLtJpSn6cuVhxu/vtGpoKjnwd46gVrXU3igPGepam2RVsSqcRzIQ0UwHMbA5B+4yBkHg9ZiXu5wjdVaLvajHyCM0sxZs4wQs3y/XJ446/VvOoJz6Ys0Vn+baXubsxwfylfSBiz7ENKuPf6dac2NwzWVlrTm1w9SAB4miz48PM53cIr/ALh97+S1LdO1Rb4amsKRylSswJChZV4kH0GCD/LqWkraGsqJKelmWUxqCXUgoT52g+5A5Pt0P0FDa6W8zvBTwXa81TRyVk1XUQsI1KnaFVG2xD5eFQEtglucEmSpURQp+MkUMAA7YKIW+wJ4HVMLiTiW0YQMup1BHja5GtK0O/jM8Qgd3hru09L24aV4KJI8dTImT1AtZFPF6tthkuBJIX8MN0ZYcYMn5Bz554+nt1ZokmMbCpnikmDkyLDysRwPkB8nH1PJyTgcANieNzg1hrXh16BLlrmjvWUyLgdSouT1/KvVqOIIufc9EcaIRK9xJjA6uxjao6rxL79TkkDA6XcaogXvf9/HXtZD9eoQc9elP36pQL1VZVwepFcjweqitg9So2eehuarAq8px1IPbqtE/sT+nU6t0u4KwKtKcdfu7qBXwMdew30PQSFJcVOjEEdQ3lkWhjkeihq1jniYwSymNHycYZvYc/Q/TBz1InnnqrqFVew1u6GOXZF6npyjKPtIba32OMHpPGszQPHI+yLhXZZ2HmPdYGoNS2+qoFkRo56reFNxlXZSUQDA7KSLncfbcc59y35Qhu74gq79b7hDRmRKqN4t9dMRJMy/7xvcfm4X7eBjAYNdekepkrllp5ZEGBVyDFNTDH5YU/iPtn3+p8dKzuNcqSot1LVClSo/D1aNI9S2DODwVP8AlX/18dfPcWP7RI3LvIiC4V3oOSSorUSrq5VgplyqErgY91jQef8Ap9T17hqaVqmkMMbRxB3gYu+WYOuQzew5B4HH69T11jrJao1lZMoikAMYib1Hcc4WMcDAIxk4H6+OqFwjqIbdKRbvw0VPIkoJG5ywI5Z/J4Y/QfbpSV4cyoSjGlrqFNj4yb3a+yOg/wCwmmu3FTom9Xa8S2eWfTeq3S3XWig9BpXq7ZGfTZik0cbHaAZDIQeAo4f0XVTWHVdZTi4z01TXbaeCeOORleF5RkY4+VlB+b6cAZPTI+JHXOtPiX723DUsFTUTyU+yKELJmKBkC7/R2IoUFxnxkkFjk5PRh2ktbahtoud7poq+t0vusccwhaVRhjIzuPws6AkSDbuAIAJHB65tkJnn7CorevKnuundMGRdt4U51WaKHt/aENXopO4VNU11Q4e5xUCQxTtvYsGlbYNoLEBTt24AP16ieW46xp6+nqk19X0g9Oir6WnoaGSY+l8xQSNI0iEbjgqvIPnogvOqYdFVFfdNM6us6UVWHaS301ziWWKtBCl44omiJDcl1KKdwyOc9DMGu9P0KUulqW/UVZFU1j1JWqtIgdVkRnlfdmQKgZUCxGTcSP4Q3TTojG7K55trQgeFBp4pcPa9tWtFTxqeuSNdHak7UaKko4bbS6jtCQBJZlq9PSLUsqtlvVkg2tJjPLNuHI49umZ8Ier+0Fp0xedLaz7laTp6276nlrKg1NUFiWGbYqSEyhcYAY84I+2eg7TFFaKG13a42TVFvnu9PBU1EtZZvQdpY1jbgxgJsQqq7kKuBt+Uk9Mj4d+1uiT2l0w2tINGXmS7VsjQW6XTUVZVsGkkG2NmcPLkgEjBVFHsMN0wyeaMgNII3WHxT5QuxY+pIIPiUyNc/C5ca7RGrbb2y1lPqrFummpIaSoWrkraGWJsPRyA7XKMPTaIHBAH5WkVmx+x1XrruZ23otaXbVv4ag9FadbHb6p6SOkFMCjiV0AqJJfkLONyRrwu3gnofrvhY1PoPuzLp3sXrfWGk6G/aelv1pUSCSjM0DrHc6FqVmi9RCWpJE3FG9P5QkmFxlfDz3o0N8OmtNUdrPif0cLtcXr5rhPfLdS/ixKtWkU5kqogwPpYkdgVU7RMysuAOmRtrFMeDMA4AUAOnKwpztpeqk4CFwOQ0JvbVGGn/iGt2ktL0Z0xZ6WS6VcEstetAQghYAgK0nLSsWBGBvfgnBHPW7b+/GpHaob9nTUqqqenJUOAZSSd2Y+WXAx5888Dz08NH6H7a/EZef8A2k2mCyLZZIVUUtvuy1M07NnbJOsWEpjtHEf5z/FtxtOBrn4Q6m301ZWaSuUs0kbNJFTVKgB19ow/1+hP/wB+ux2NtDY8uVuIkIdQVBAArShvc0rfcuf2hhceypibUX33pryv9Ula3VF4ujy1VTXq/qHPp/wlTzgD6dDOo6Ku1FbHs1DUqss00NTUqm1vSpkkDbnU8bWkjSMAjJy2PynFbXFq1zaLpFp606aq6WekgWa7T1ciwxw+rvEEYJVjlwrN8oyFQEEbh1N28e+aalrZZkSeqpWijq64xH+8ylA2fm/LGE9NVB/yt55PXZydji2HDQNqw90n/Eje0HmKio0vvoufaZID20ru8Lgb+RI5Glt9tyYmkPiB7kPaLbXGhoYFWORKiKOp3RiVHZHUYXO3cpH1H3PRVd/iJ1dcaSmhoXSkaNQXjQkoG98Z/Mp8YPQK9dpy63iS4VNAtJFUx7pYoVbaKg/ndR4VWAQkLj5gTzuPXq5UdrioYqamqlkZHLJLt8qR4J/6dBwex8OA04iKrxa9PrYAX+VOJ2hKa9i/unhX6XKJRda7uNBGdUXWCEUbFqVPRDKCx+dseygYyB9uvGoe2doordPUUtzp7lV29DU08tDA7xQ1BUrEshB5DZIZRxtJOR7BVaaK204rZapoIYwC00p2LkkDg/qQPuTjrzdtbWPT9KLXddXWuKJj6vpR1qSZJA8qhJzwOCMjomP/AC+F/suxLYgb5SWi3KtD+6BhzLMc7Yi88QCUw9F9tzfLdQ36a9y22GqSOZI1oHneNm8qSuUyvudx9jjnqDUmnIZaqqhtyyVdOoUGrlUQuQU/KycFCTnz9OOlTL8Td5SgSwWqohqqClqC1NJEKj1iMY+YgBeQfH6eOgK+d1tZ6iq4pH1BeqaionDLHTlKaN2Q5AGWYsoPknPPA9+uLn/GsODq4zdsRUBoaQCOJcRv/wCXhvW8z8OzYigEfZjWpdXyp/C6IHbCnt2lXqqWroquKMIZoN7VErbsICxfLNhVA54AGPbobjsVqhY4ttPu8fNGGxj2AOcfy6XVR39u1NDF6lFRpJKWEcX4wtJKx87VGAuce5AH169Q909RyovpwWutdiWMtLHIyEHkAYHkZ2+Acqenovx3siABha53CjAKDhqEnJ+GdoykuBDeNXG/PQpmC3UkkomeljZ1T01JXwuc4A8Dn6dWUgRFCogUAk4UYHPSmh7wXCbdi6WaFkyjD0mJDjyOTwft1dj7rVJUF9QWrIHP92bGf69FH/qBstpqyGS//i3/APSGfwnjzYyst/5H7JoJFz1OkZJyelvRd0KmplWGCqtdQ5AwFVgW+vRDS60rJAg9azuTgkeqyNz+p6sPx/sx36myN8W/YlT/AO1McBZzD4O+4CLQNo8Hr+Bz0Mxa5cypHPa4iGO3dDVKef0PWlFqe2ySenJT1kD/AEeE/wA/Gem4fxlsWc07eh5hw9SKeqWk/Dm04r9lXwIPsarXz7Dr8R1bO11YqSpwc4P0P36HLlrO2PVJYbTW7rlVxh4GUDA+bB8/xfqPfqSgrI7Pcf2PUpK85rXhLU+BAS6q4aUFc+qSWPBBIOCMAHp9u28LI8CB2dtgSCCKnQfJSv8ATJ2NJlGU3NDaw6siIeOpoxx142569pnrVddJg1ClU9WVPjB6qDqZH9uhOFVbRWQfbr2hAPPjqBWzz1Ip6C4K2qsoeevyviFRbayDbn1KeRcH3yp6/I+VBJ6sxqGG04w3B/n0tK3M0t4qWuyODuC5UvV3q6useSolidl+XES4jQjjCj6/fod1O/4m1VkauWkaLeCRzkYb/t1p6lIprvV0pmiJhneMpEuAgDEY+5+/WXUFZIBEzH95EYyCP1GP6dfOJW1BaV3MZIIK19ORUUun7fWtRQQYhBCQsHUAYK/oSMk5zgk+evN4t5udBX0URwJKaULHGCSwGdu4+WwCOTwMe3WD26q2bTr0v4VIlirCpMcgLTNjDFs52YGweDkeAMZ6Io1qptiGMYyrmJOB427mJP1Hlj/Trnmk0unZAA4hcZPqu7Wuje2iul/AO+a2limeNav32yFCCVzjIyPr0x9B9vb3r+O23CW+i32qtjw8MZWlkbg7thOUxkDDvksMk8+Yu0Oh7F3G7v01shot1gsURrZo6sbfxGwgIsgPs0hHB9hgnp/sY5NRPMxAjNT6i+moAVQ/IAGAMY4A46Fg8C18YxMmhJFOOmqaxWLLJDAzWgNUNae+H3QtmjlpY7M92lm+ZmrJ4ZZcAnBAp62IgfcJz1Fc+zek9PXCG43DSFLFYHbbKKumnQUU2PllM8sU26JiApQlgrMDkAnBZXU9krLkl9ms0D19KsnpT5O4KDtAx4Odx/Tos07bqfWdRQ9vXtVtBrbhNJ+KnooZ3+WHYYv3oZRGzBc8eeSccdbbsBI1lTGBTfY6cUicTG5wDJCSRcG1+Wv1sk9qjtf29tun73rC0Ry2ertNEayOe11SxHeJUUAgLGf4/wDIOccg46a+gOxfxbaWtGl+43w793LperzW2yO7m1VlNTBEEiBpEV53I2FSOGVSeFyT0EdxrNLQ9s9QWK3VcUVFPPTUdTEuJP2eDLu2xxQSYCCSM7g6LtBOwkDZ08+zvx5aN0BTWuGt7cXC4UtvtUFu3UFziYmNFRC6RzJGznCD5fv546z8VFFU1FHU3JnDSS0FDUV3rG7jfFT8d+jrLqPR9/7XUlxuVU8tmodRWCyTgUdaUUuHQKQspR1dA6DO9GAYY6x/h7vej9BTxy36090ae/1kUdbqTU2otJRQpTTtThnZq6Ys0cCLlUckHa2QAznPRL/H38M2oaqasqrJ3B0peZk9OSup7TiUon5d/oyESKo9nVgB7dI74oPie7a9y+z2q9DaY1pJd7rdoKdbTVNbpqBXQTRtIJA/yo4CScj5G4wQcqIwOVkmaR1xpUV6qjYkksowa8F77b6u0dr7uDH3S+CzUkOldbWJUfU+ndRRyUFt1NSSuR+8ZWfMysDllXwwIKsMl86h+Kn4oO3cktg7q9l7S1JcpIko9V6VapuVJQROMvJJRshnqCgzjaAGYfNheT8e6rSWuqqMzTuKiOFTJvFRG5QKOTlSWGB/2z7dXrS3du2PCE1FqmzwFC0Mv4yqiUjGRtG4Zz9uimLDSvq7jehHsh55mtoPUFfY2y9+/hOu1jl0latbWmorrg809zhvVUYbrV1Zwry1CVKpI0hwoHygBVVUAVVADdUXvQugtQW+rtMtsaz6iVLXULLVqJPxGGMGB5Zsh1+mGGeB18yF7ld2aqsgbWGvq3U1JTuh/B3vFwhqI1YEI4nDHYcYIBzjOCPPX9W6kW4V0t9FutlqrBG0NPBabdDTQRRtnICbSCPb5txx79beCxj9nw5IgTvoSQPn3CycSyPEyVefMCv2+V1J3X+IihsmsKK06co9PXekSCUXKanmcyRSg4RR6fyscct/TIx0D6j+KHVtxjFLb7DR2wU0fpvUCnVZGwOf8U4A/wDKcfXpK2+0U2o5EEGo4KJfkjnpKkSBl45aMRRlGTz/AJWXODn8xjktNJUSCmtNYKqR5SqLIfQlePjbtRuHyOQQcn6dDxe29oYuQuMzmN/7WkgDlWx86+GqmHAYWBoAjDjxNCTzAuPTxR62sb/r/wBKs1Ndaie3wKZESetMpbkjKRkqvy+doUk84GcAsTT+mtHQWCp1LXanmqvxDxmktNDAZHqEPCxVLwgGIyE/Ku5SpwSGIKhG6Xp3pNV2ykloJpt9SkTUmws4jL/vAgbnxuJOOOTz119qu1Sw0EncGgkt6V7Qy1lHaaCIGiljWMgyBVwFYLgGqIB8KQQQnWBNg2h1ZKE6km/vVakeKzNo2w06oknc77pjVFW8Nn0y2m7bSOGKy3Od6qYjgqSrMCxbAAGRjP8AEcgw0r21oqKzx9zu4GlIY7JPVvS0pjA/B0rxtjE6tvKux4UMSp5A+bgLXTWjdZX/AFJSU+l7e1ZcKuQNTx08qkwZOC55OxR/EzYGP1A66U7e09clntVu7qXOSS101XUwWyClh30dXVPK+4CM/mnYkhTIMFcbSBnq5giYO6QQfbhbmhCeR2o0VntH+DvK6hSlsk0OgLK8M9TbgUjqMOH3SPkAvADHuMG4Nzk78CMe+9DxWXTsWvdET1Vv01eaw0kiR1hjFeSjFmWNRmmHy7STh2z8yqOSRad0lH20v2orldrQwssUlDUmzPVGX8C5jcxyY/LUMuf8LJ2lv3e8gZEO/ta180rTauaijoLXNcfTEZB318yxOBNURg4RlwVAI9XBO/wEFI2t7QZdK6Kz3HKa8NUjbulvqblBV2xJUopREs2YyFiy2NnJ5/XOPpn2/lq6k1G2F0FNkqEUHaoH09yft5+vHPWcKyaSugmqMiF3jVlUY3DcOf0+/jPW9erDUx1Lrb5t1FuycfmTk8Ae5/162G2Nys11xYLU/ZdSYqWp06/qKYY5poxwyMQDnP0H+nWzDdql6RHp2/vLyNHKQmGfbjyP5/8Ar1Ut9Y0ltt8VtnZGER3DHLkMy5Yjz+XrTEUN0o5ollENxjkjw6rhJdwP0+pAGR9Orsr3evrxUOpfr+Fp0LPcqOaakkhNxgCbo3HyyA5/LnjPA8+c9GOj9aXWVJqG9EPPTQM0EM/DHGBtYEZwATjkHj39gXSn/uS8TUV7SWKraCQooVSFIG5W54J4yMdFlClPW3Wlq9Qy7TUSJFDVYJZ1Y7WLAEEpyfJz9OrFocDW/wA+H2VQ4gilvjxWjPcqGCoqL7Rdqaa7VNVE4r1jnSndxFFlFQOwyWIwQvPnJJ6Rnw46Z1Pcu4V71fq24Xa32m1rLVyxb5VC1DMeMEH1NiqRtJ5wueB07K6iuD3WS2XZookUOjVQfERhIKnB9/0xnPnqvcqyn/tHQaZskc0DUU7xR1SyeotavphZJKknADbQSW427RkEc9Z+LibDJnjAaaai3qL19k1BK57KPJPI39Db7ph6euFr1FSPUWe8w1ixKWkV4xE6D78lefbx1cjRnjMsQ3oMAsvOP1+nSlt11o9I6sGj1pXiknl/D3GOWL02q5ZMbJox5RVJG0DghiffHTXhlqdKQzachqBJPXAYnA3q8qnPoNjxhcj6EjjPt0ezPxDi4o8r3Zxb9VzTjXX61WPjNlwPfmaMvha/Cmn0opMkeR1+q2OqV0lmmuNBZ7bKKerZ9ju37xS2QZEYHyAM4PkceeesSg1/appqyOvU0cNLU/hRUyMPTLnd8re6MAuTnjBBzjx0uE/E2DncI5u448dPru86LLm2RiIwXR94Dhr9PsixHPt1YjYHqrHgkc8EZB+vU6+et59DosmtDZXI/HjqzGcAc9U42yRz+nVlGIx0s8KxXLXc+IUusbtTLMpKVTkRxx4CAnPJ9zz0N01PLPCNpcbHOSfygH79Mfu7T0/9tq+mesy7iOYU2VjUBwoDM5IzlsgDk8cDoaNloKeOSlkrXrK3cuaWnH7pTnGHfwCM+/8ATr5xiyI5nN4E+67rCgyRNdxA9QlxpULbdR3ymRSSjkF0kAABbeg/1PgZ+46NBUtLuEeWCFnEacKvO4E5/nyx/n0F3Kgjt/d1KSot241lPE6LTyNsRyu1mcgjIADZ5/QeOjU2mojHpzyZERXMaABU/hyRwB+p5+/XMyENcQnpaggoC+G5dO6S0pddTX64UsL3Vo1laaJmaU5b0o12g7VJzzkbmyucLyX2+UzpLUY+d2XaF/zsDg/zz/XPQJPTSB6LT1rrXjpqV0aC21NNuAjCna8cmGVSTluHQBi36dFOhnrvw0ZqoGWOSZVRjyWYsvCgZzjk8fQ9Fw+JDmR4c0FPkoksBD3za1+EYVtjS3jEbuWaX0Cp5AAYMT/Xot7N0hl11TVJT1BBS1Ex4P8AEce3P8Q6xHp6ioRGdJQXy+11IILNgZ6POy9HHBf7lVFQBFTCEEA5+aQAAfrt8ddXi5cmDe4HdUeZosfDMriWgjoXS5+NKtjoIjBQ1NQpu+oKOWeJah2HqCkaSVQDKwCs7q23Yg+YZVhhuuf59KVaW39pQxvHACxiQVaFnT5cFY/OPm/lg/Tp1fFtc56nXWmKT8JFVSNdq+pWnq1LxOESCFQyscFTh/Hy+SPfpZRaIq6qOWvGn6iKkhp5KioljrAPQK4BG3cC+C0YBHndnjnrkcVKWSNqaCgud/LxWzC0FppxKELfcrlRUgaK43Wkn2nPo7whJPzDg8jk+evE12qK2ola43cSBwELVFNywx4BA4A8daVPaahKWINbr7G4iRz6W14yCByOfBz1/Wu1PW170klwroi8xBV6cfMFAzknhSADx9uOr0aTWimrhaq1tO6DjkssvcTU9UKXSdGGpzNSITU19SciOlp0J5Z5MIXPyqCxIbaR0IXK3T2e0H8VMWudZUFWjEvqJTxAbvSjP+XDAFvfOPbpvd+7rT2qPS3bb8YIYNK0SV9egkx6VVLGMQ/XdHG20AkkNKRnIPSTvd2lvE5uLRenE6elDEMDagPy/wDcn7n7dM4ePNIOAulMRLRpAWPUESSGVRkZ4yPzf/brwwRhgEAYyCf+nUhx4P5c84Hk/TqGRtrFgoz/ANPv1pUBF+uazqkGo65KSjgFRVxoztEf4SnBU+36dGj3K0WGrpp7taYayqSGSN6Nl/cMhAVAD52nk7vzZGBjjoM2SRpGyuvqON36fTP0Pv1ehgkUCaq3M8ieqS4yWJ49/wDr/TobmB9OJ9ldkmQHl6FNn4dYa+86+K1lRP8AsqjpJTPNNPIKeleQhImkYHcq7mwMMoLbQzLknrorXNr0/R3m2dpdM3WpvGptTRrb56Grm9Yw0+TI1QcsqQvtD7UPyvn+H/E6WfwuRXam0rqSmsEUNDWaicQrWVKCQmkiQ+pHAjKUdtzncWzgYO0+QYdt+1Fx0P3Wt+u7KtdU0i0VW09bTw/iZYwQsbVECtzLjcV34YDkqJNuBkzsYXlxGmnitOF72sArrqnVZ+3/AG50jY5aPtzSVgv1vp2knrSop62jkRCWNcSuI0wv/wCXKkMB8in/ABAK6Q1BpPtrpyGu7mqauvloysP7kTRV8bgFoIEI2xnLDesmP8xZgOCXXVwt1R2+v+oO38ZiqaC3zNV3tJi8MySDaYp2bP4uR9/APzITu3x+G540x3EpS8lvu1iW4vVfLPHI4DzJ/wATEECNfsMD2GerQxl7iTuVJHhraXTV7aava6V1y7gXu2p+zaO4rBRW96p6mS3IiKkZgLn+8OAcY/OBxHkfL1a+JM2/Veg6HWKxQ0tHPWmD90f31TIsbES1IU7RIuCoQguoJDsThVDe2mr9HaXrm/a9A6wz1E0tLKoklFv3MVwqHJKkL+YZkwOcjgbffdZarQ9HrLdBSwXGqCwU8JDNONh2VE5UlDIBkKBkqCQzE/KsCLLI3x081Jlq0jlr5LnJLTUwVUc9fM5p12uCDhyD4z9OiK4TzVNdNLTzukUcuPm8LzjA/wD9j9Oh39/BIKuSeSRACzKfLA+c/b79F+oLEa2vnmss7Iihd0b/AJQWUH5SPfk8da4Jc/MTu1/ZZtKMygb9P3WxaKGhvmn6Wlo2nhuaTzIPdZANpAf3B+Y89W7Busz11vuhmWqEDFGzgA7hkoffHOSPr1laZqo4tP1NuiNRG8dWodzw5yp4I9gdv5fHRvo+wNVPVTXSs9VIIt6wAHKg4G7J/KeeOvVoynA6efFSBV9eI18uCgpZaGnqLdPfImqYGEeARteMbtpbPPGM/Y+/WxdtN3ahlmrIKpquypKwkqNmWp8H8jqOAfGCODn26G7hp+6UqR3GCWWqtUZbfJt3OoJ/I49jn38dH1mvs11tlGLbUyRy1NGYDTZGwsPL8D829BnPt9OjuJLj6nh1xQ2gBgG7cFtJWUF1sdLbrdRxVNNcYEqpoHGJHqskSS7vOeGXg/KAMcdA+u7aNK0tRU2QRXKjuSE3OUMxlVogAExxhB7suckgnA46IIa610dgqvwVwjt9dSzxhw0e2OX1c71RvKKWHORg5zwD1/Wtaanpzf7vBEKq3rJV0FNLkxyOEKmSQDhowMnb4YoPIBBWxLWuhoNW7t/iff3RIi4Sf7t+7wHsr2mbVRaj0Tb7xfZZqLUcFKaCirF2NUUIKZjMnvloyAAcFQSwwT1etdZcrLTQXO/LHLXugVcEmOYr8rTL+uAR7gk+46H9JVFLcNUXCuhpxbqa7LFJUQpIPQmqmJKLHngSE+pwvBU5+U4yTiaXU9ctkkUxwk5KPnNGB+c/YDnn9M9RhQ1zC47v1eG7r66r0xLXBvHTx6/ZattoI/wtVqKYNJFVo0FAz+fHzgsPBx8ob3II6UOuLO8V1tdCokEN/q1kmkA5WYsix5HsQoyDz+dx4PTUqZZDV01ppZQKKIBYpANoEIGW3r43DGSfv79BN9hu9617TGBoFtsNJUVYSQEGGZVKx/MPzLvdAPoG/n0DHRuy97X50H1Hr4pjByCvd06r6+iztK64qLTeaikuJcW+tr5wgYlvQwAcL9FBzkfQg8HOW4OucYJY6l7dHMJIJZLs8FVvGSJAiRsM+4dcjPHzD6r05u3uoxfbKtPKT+KoVSOTPO9SPlf+e0g/cddL+EtrOcTgJjW3d+R8jzWPt/ANAGLjH+74P3RYmV5B6tI3jqtGpOOrKqR12z1zAXOnxKRiDVdFL+NjpxWUkZwyA7ijMPmJ4A8f0PSvre5VXNDU09vpkttEivGSJFTcRzgtjkZH8PPTW+L5Z6a2WG4R1dLTRl54XeYAnwCMZOCPtg+3HXJcldbq68K9uN2vLodpMnyxRg8FjgAgYP1UdfNtstLMY8c/e/Vl2uzJP9O3w9rdXV683yOuvNJWxVlQ8oJjZqdWjbnxsz8zZIweOc9dJRVNjNnprtV1G6CpplqApIARpEDkHOFQ7gfOOuVdc3hZ5tPpaB+GktVvSOqSnlUxLMrscx4J9iOmjZNU2y9dqIrE8sk9xpH2NJLGVBxMXWQuQEXKuQefb79cpia581FtABzQCizVlZJfHjqKjURio6SmX07hVKoQZfbthLBhKFHlVbwcENnj+7dwVUl7kqK25Symlj9NGn+Vdqq35AMrGMBMIMAYx7dDWo1k1JdrrVVt9zRUwhzJPTsNnygDaQM7W4AQN58gYyPGmrxV2J9toQSU09W1PvqV3NHF6ZLEYOF/LwfAz1XDPYcUHuNgfZMS5hBlAvRO6nSJhGxctGTBuO8jdwWJ+/tz0zux9HGIK+pgpVjBanh4GMcMx/8A5Drlmk1rryrWmrIrijJL+CDloI9q+qx3H8vGYsAf18np6dnteC29ray56lrTFcqi4yMVjVYsQqyIu3Py/KgBJP6/XrVx20cK/DmKMd6vpqlMLhZxKHv/AEpMd+ZI7p3nsdLPRUc6QW6qq3gqmMULNPVT43n0kYcKp/LngZ3fmMP9maBbXf4KXt/ZRLbLQstRUUV+YKFYMyuQceqRtJ2/YfXr81tQQ6i7oTXcQ0FRHTW6ktwjmAKxsseSWVSVGTISckgfUnHUM0dslt9Rbl0hYmepZEhqoF2SYDYLxr7hsYzj3BzjnrBxuJbLJVmlutQtLCwFjAHaokh7ex2t4LbJ221rBXGMIrW++LKhkAUEj5sDn248jpaVMFLQyXBa1brFFSTVL1kdRKGkY+q6rGmMgSPhVJPk78EcZPJrZHaoRWjT34dTtUpR3hsx55JLLJy3uAFAwPPB6A9Tarj09WJNaoaOWX8LM26rxPHG8qldyckOyoflkPIZiRkhWBNnueXF+7x/coeNDQ0NrTrwCXeo7Ve7/rb9kT1C1dTDLvuBjcNGJ+GYF+chM7M5Iyp8+/5exBCVs9MAwoy6TTD/AH0gY8j6KFAA/n9eiy2UCaQ0/HdZaWFq26SNhD8nqqU+UbfZFYBj9cj68iFacFgJC7vj1ZMeec8fz66HCguBcdOvZYE5ANAssxEFiQMg4bPgfbqNacEsFfKjJz9fuergpmlkEQCqzEDBOP6/1/160qSjipoTHPAJJJj84PBVR9Poc+/2HTTifhAaK66aqhb6CCuqo6bJRmcDByQVzyePcD29/wDTrfrZ6avRF9JjGzlIVQc+AAcfT7e/UVPRrb4ZJYpA7VO2KCQcEr5Y8cqRgL+pPW5p42p9S0lXc45pKW3TieqWGLJmROcKBwGZhg+xzn69Dc7fu3dfCIxv+O869fKfXZa6Wu9Wm39utQ08lBZrDAJKlTKIXmnbLvUSSfwIpYgAH2+YkfL047Lrqtv813rjdqiG0UsQs1vvMVG1M1wMW5jHngUxYug3KB6mz5PTzt65F1R3WuWqdQpeY7TS0dIu2OOkiGMxqcqZHGN7A+PYeAOuvtEU1Pf+yVNZbncIA1JE010tS/I8ssshdpKpmxmMrjai/JgZZmPCoYiMtIrqU/A8OBpoEKXGy6svFrfQegq6Oks+oZClWrgikEyL6x9H6SExEO65Q5G/c3IVUFnodFa9W36ksFRKKZdstukYxTs5ThvUz8uSchwSMcrnx029W6x1RpBbcbDTyx2+KGZrZV1EXqyxIwEf7vPMkQAOxmBxkjLgAiKksFk1xZ5KG8U0tdcJYXqI7iJ/30bsc+tLKQRs+xznGFH0mJ2Wp3HqyiQB1Ka9arJfRl3sPb+16srKIfs2siHo1fqq3pJJIzcrgNknI34JOOQoxnY70WeOft9S3ecChpHeNUpYiMzyhARVSqD6auQcALyRyxJwFIbpW3fSfb6xUV0tVTNPDTpDQXCZt1NFCIxhYFA/dyEHLFsux4BK8AO19Zq+ydsbXJcaOeigkb5aadw+aj5T6ohP+EMH8hPJ52r7wwlwbXj5rz7ZqcPJJSHSt3qoHulRLvpKPaWaJwJXVs42ofmxgHJxgffI6I7u5rbl6VC7RokUZWMn5QDGp3cePPnrCnkuESxVU1RtQs26YHO8H2A9z9jx0SV1AKhLfU2aT02lo6d5KZuC7bAOG9/H5T/LrTFc9fXhp19ln2yEU8uPXVVe0jFbayhvNsrqiojqEpkmjqYiM5WQDGD5XDn3z9D1dprbV6fnprvcqqRqLKrG0GQZhn3z+QfXPn79Z+hVprbe5ae6PunnpZxHDtDCNsFhuz75UcePrnrco5btVUsm24rKgm9WSWU5G0jncvvwPA680A5huPr1/Cgkih3j06/lFEpna81dPbKo7ZY/kRmwix8MMY4A5z1s6dtdouluqqe1VRt1zo5opN7LtimzksTxmMFlH1HgkcnrMp6CC6UFsuenasJIjNFNSS4X1vTO3Ib/AJWGFPHPnq5oiSjtmpUo9Q5X15jTLFtBbGcjeCRj5wuAfvkYPRK0YHOGm7fbXxVKd4hp137uSv2jTtAt+Sn1miR09VOkUcLruWUbgys2CP3Ybb78+MYz0W3e0yaoFOtY1O1RSM0E1SBtCQjkMwA/KBuUrj2AHWxdaRdR2CCGWupbslLKCKhmERFPJySRnMRjYE8cDnGfHVa7gUFvaostTSXCluEUjs4BSb11JwzqTnHAB28fMcgdVNMxrqfT7GikEkCmg68wkp3Hst60nSQ0FLbxNZacpUWyro2Z/U3Y3ktjcs24AgEe20ZHTbp6XNngeWQQ32tiLTspU+nImCadtpIznJIzlThfbqTtRSVP9kDf7pbmkpkkkkoaSeXO9GdW3sp+bYGLlcn82SOB1+jRdNR3arOnqqoe01LLXCnlYu8RJ/NGxPJPKlfOQCOk8M3s/wC4P07/ABTE7s/cP6tyxMz2uledwqz13KRMMo8Q5YD7Mf6gHwes24WoyaZr5LbI8Mtwb+5neN0RjwQCD5UsQvP05+vWneppLxNBFSISs+FjQg5hccFTj6fX6c9Ub/MsjxUFOyPFTj0IHTg/KcMD+p+b+nTr2Zxld5+G76fBQI3BveHl8/X5SUqZax6uwVVRTLNPPIk1aixlHkElTgSqDwWBRN6+zAEfmJ63tHalfS+ojLLJug/ETUtTGOTt/wATgDjn53UjgjOMe2nqmyBtc2m70W4xGrp6eoj/ADRuqkAOP8pYLjPjcBnBPQAaqUU9YcNUPSzwVC7BsM0W+T+DyJV91H0bHgg4DZJcHOJG2c0ghbBYzERFhu02XVkDLIqSxsrI4DKynIIPII+x6srz0gqLvLeNELbLANMreLdUVZpIq1KsxmlR03wBk2EsjDaA2Rjcuc9BF8+O2fSmt6zSV77Yq8dHWLTmpp7qQTG20h9jRkZ2sDjd/Pr6XB+I8DNE2RzqE6ihseGi4ebZGKjlMYFaaXFxx1TV+Ke2SVHbMXOnanSS3Vscm+YcBWBU45HOce/XDlVWRVFaiVl7muoV+KOji2xlvbcfH9Af166J7ufGRoqtptS9r77oK9U9QkjUgqlqIZYQ6sGWQr8r4xg8c89c/XbubT6micrfqeipYUEaxUduaFwpOcDGBjj6gfr1zG28TBicQZIXVBA+vnRbey4ZIYQJBQ/Gu6qv12mNSXWnqJbfaaenpjTM0xMWJGwC2CxGf+njocYVt3/BNFW08h9JJSDKIhCi/IC5YgZwo+bA8jph2jXF2uOlaWioKwUlJBAKaWqrMRloxlRkLzI2PoQMYyelQ1PLUW+Wlo0gZYpniEgYK0jZyoPt4GQSfc9czMSHBx8OrD0W+Gh0ZA8U9NS3iGWjr4xXQimgrnhp1hhZMIMA5jZQzNkck7/puGMdT2CjttyqaWjW31340q5jjieGKOQSBU3/ADbipyxx4B9/r0toNR1VTJFRW2khq5amTLSxRxpJPuc7BhQoYH3JGcefHGincyXT1X61rRJqZYRBDOrF/TTcSfRYjz82NxAwACvnPWaWEOqDQlaAcMtxVMTVdJU6RMdHUT0kFTTvIkEEFR6v7qOEnAyBgE5+ZiuSRtBGMmWirZfLnoakutv0vcKm101FJUvLMrmEvllEQJ2+u7Mw+ZSsZAC5JBHXN+mdQ2SrrHrbtZpa2gqJKgrClYVpY/UbBBVVJBHA4x9fp03oO+kwgo7B+yrk1JSbKWOmp7pFsgVMAL6JwQBnIyOeCCeiMwzHf9R1178w4foag/UWq54df32nmhcT2usloZWjkX95tQbxuUqcZHCnI4H69XLlURU2m6K8NpqyCGWSCV/RqmNRIM7sSeTyMgknjJ6NLvpPTNx1zb71etU0EtLRMK2Sgqozy+MFZGDbXidlbKsN2QeVIIO7qqp7YW+wz08Xb3SclZWsBAaGmkEkCMcGbAkBIXGR5GTjB9yuw8ZGZh0Q+1fWjkuDXW2atp7hBphrUssO0QQ1Bf8AEO4YIW3EEKCNxx42c+3QfbKCjuN5/C1NPHLA7DYu0bZ8bjtDZwE43MfYAfUDoy1bqexW4S6fFul2wU24VMzFW9NmLhflGY3c88+20EAckb7fVVfc62sloLTRpSTLvqWqSWipyMqWDcMSVJ8fTPsCDx5gwMaErJkLi9xXi7ad1LcVr7vWtNOtJFGrNMoRliBwAkYzhAR58nyehuK1VNTKJKpRFHj1GYkYVfsAfOMY6Or5d5KijVUhnplaRjG8U7+pUODgO58jAIOPfI+56y6hqhKGIzRU8s9OwEu6Ibgh5RWI/Ng5znxletmDtGsAcKDTrzWbM2Iu7p5rCNlQ1SlCVpZwZN5xkIPzA/cf+n16nnCXIGWnpys6jasQ53x5wCPqw4B+o5+vWtsjq6I25xHDUVmHRk+VI8eN2fZ8YP0AU9UqOma0+tcpUJqqZvRp0YZ2Tfp77Rkn2zjowzEVOoQHBoNBodVcEUccb0FSyClpIxtIGWWQH5nH/EWJGPcY+x6qvRy0NKtOZVLVcvqBkPBiT8pH6kk/XgdWmpPxvp01BGqyVEyesmciJz4P/JyT9vB9s2KipjmqJo6gn8DHhKZSMyoqgKrge2QMlT5z+h6qBShHmra1BU2lrbSXnUlvpqpXVEqY3qWQDDxAgtxwA33JAOece7m7ga61HR3Gnvdujoo3tNVHDHSiITJID85jmBGJV+VcrjbkAjkZ6H+w+n//AH/WVtTSrcHMHp0kUIDiUMMswzwAAACWxjJB5463u7mkpdP0cKV6xUlPcqr90KXdIlO2xSQx8tkfbAxxx4Ecrn0IqEYZmsroUcXjuLUdzP2bqe5W97PE8MVIWDGQNIpJf0mIwAWbOW5AA4PnrbtcdFZ7dK1iDetNHO01vcl45xjaZyc5jYbs+oeGIwQT4saK1JYLP2apO3tiscV4qoabddKqohzHFNId22NfLyLuGH/KhHG48dC9tkuVDY6n0FWUVrSwu5fFR6igklgeWwByRwPoOl6f2yd24o5NXjjwTK0LqRO7L320Xe20dPFb4gaKEP8A3emhC7XkYMeZCFBLnwOFx7jfe2wyN2/t1XbrtU1Vqmdlp/x7cGZdu5Y3zvki2kYdx54BYDI8dgLNbdXQXCx1atTSW+D8RG0bbZWnPl3JHzKNoAjIKe7Bici/8RNW66et2mLhfKCultrCsd7cwMpSVQFR4jzDJ8hypJGOR52iC0MmDdBUKA4uiLtTdcz1dHePRgU02JWdkfcAECD3Ptt5HPj6c9GMwFuttqa2PHJUtSKskpJ3YDupCZ8D/wCbrKqLlBPZoompy1N6pURKx3LnGCG8luP/ALdaVZbJLfp+2Xb05KmBRNEBgfuiJN37zB9t3tx+njrRcKObmt8+PXms9pBaadeCt2gJV6ipKi74p4BPGkc23EgyQCAPdeTnPRFW2S76amr7dtino43aKGanyyF1bjOeQx+/8ugupqpa+sgRY3kkkjDIUOChHvzwAPPPH6dNqouaWa4xVcX96lr1inllODEEdRlQPcnJ5P8ALqzRSTmRpu66oqkgx13A67+uqqLRlIkVnq5JnpY7jA61ENO+SIiwClmA4z+Xj2OMjohrqc6ittpuF4o2DxbqSeuUhWh2Hcsm8ecD65zjHnoa07bKa6ailo7fuo55VaCbc2YW38Bsk/K2dpAzg49utl5JrQ130rd7TJSywxiQRzDa8jo3zNxwcjxjOMDB6uwd4x6u18By+yo890P3aePimRabBWUtsju1tSmrbTdqd5KmqhDM8Ers20upAKIGX24GSCeo9H6SodWTUrViyQx0VbJN6HqiL1pFQkohx+Riq5x42/fqPs3LUVtIsVqqaxo6N5alIY8b5IwBvh5PILHPg8b/AH8nl6sNlu0Vv1BZp2sF1jwIyd7QeurZ9KVDyoOQQw9iQQeOlnjMDFrTU7/PjXiPJFa7KRIbV0G7y+31X9qHTlNXLR3iz0QoKmsYUc9OgIiWZflAK/wqy+COBk9B16pHslG1jkeaKvhUVTbuBIMncowSPl+Ugjzz0e05qrTUm03c1VJUV5dIdwKpCQMKMn84JJXcPYg589C37Prr/daW1TFUeGqFO8sv8EZznJ9iBnB98456mN7QA+vcHXppRecw1yf5Hr90IW+nSOSbUk9S0DTn0qRiuF9ZgQ7k4wABxkcgt9uhmRPQrpKqUxp6Lb33HxKvCnH3J/0Pt0x9Z2tKWjjtVJMZ7UUaOnVlAaFlPOQON3ufGQegWoeKlss1HXqkk1QFNSAwLLGpKofv4zkc+PIJ6OK0pvPt1bx8VApWo0Hv16INhrdmqokrqaRbeUmnkeM4CsqENE/+UMWVlYff6dLq7Wypskl1tdTVB4Uhp5qKqkXcwT1gFLMPKZwGPlGAPgnLXobZC1BdRWx+rDNEKQEk/Mp+fcCPoAOfbpW3Qz2+O/UFzlqjDA1OY9q7mh3sx9dP8yMEw6Dzg8ZGesrHx6u10p9lo4Vx/SoklmraGhnmpyr1NL+HeMEH99C7KFH0DquF9sn6g9cofEVamtncOStQOKe5UVPNDLswshVAjYPgkbVz+o66dV6uj05FXI0E01FWyoiIcGoiMcUnDeAwxnB4ZcMPBzh9wND2fuNp+WxzP6Dwn8dbqtky8KuActjyFLKrr5wxPOAesxkhiPJNuia85t65p7xkTauivatlbxaKC48AgFngUN5/4kPX9RWqu0ffZrQbzb4vxVup66Oqng/dsjosi7QwJB+YjIBzg46td1bLcbRYNGC7Ubw11JQ1NpqkIJw9PUNtwfBBR1II9sdDl01ZUVdTaLmlGvq0FshtzCb94snpqy5I4wNpAxnjHT4deoSTWENDeFvomTo67W5qmoFZWNqCcbSqzW8TDfnj0w549ySQFx/LrDvzyDUlxnqraBNLMtQqIyske4c5AwgH6DjrZ0vWUy2aluE+pJIKquhD01FbqOONFIOGDY5Jzx/ToevN6prveBVzVNdBDJTtA0sqruJTOBgZwM4B8nz0tiBmBI6+U5AQ0ZT18JlUVhptJzrpDSNVaqq/Ogo6i4Ozkw+BIkJA2BmG4YGSFz82WIWt3Q0DT6J1TGljqKmmFwsdNcadJ1Lo8bwgEerkk5dH8qADgZweCSyWO0aRrTd3u0l1qhG6UUMrqGzwWbCk7MgkLnPG76Z6ZPcbQ/cm+aT0Jq28JYliloxS7qMu09rtyMW5lICqx+Yb13MG8MBwMVmI71QaneVrGKraUoub9Cpe4oJJtQLQWa1gCNJJ6wB3kYZykKMTKcc5C49iTnHRTahpS4VNPbrfWVd0qpquMRCslEQhzJhSBj1HVc525HBwOOqHdXQcVi7lGTTGnbbNaLvSUlZRSrUmTJkp0Zwq7yxIk3jI/wBeqWhKOe2a6s8cskG9awyyKEkjVI4gXYkuoAVQpJJJPHTTKTOBrrw6JQCTHaiY1fb6WluMlLrjtbeXeadj+04KGE0tRLI7HMjfni9xgEkcffrRo6ez2Okqa63Tx0bBpI6anjiYIZAQdkjfncIOQcuAfcAjGdHUVN7gqLtdL/cJ7RumjM87qC7rFhUhVRwWwPmOcbvI9seq1bc7jthoUglelUiL14WP4VTgKke1zljnkH83vjppsZb3mtoOuKWfI1wyE364LCvlhq79IlspauoNfVVRE6H5oyMgs7yA8k53bfpx9OjBqa1WOxrb7N6rwQxxwysRgTS5c5b68848AYHW3YVls1kqrj+waSEVKAztSIIlLnCll8hR4DMOPPBOB1lz3Jr3VzUsVLFHHJExhG3CoEG7cR4AwpyxGetPCQvc4mTdTy69EhM5jWgM31WRTCR7dWzuhkanxNGSfzPzuA+vyksfsvWbaoHmqXqq1mFHGjGrf3dG4KKPdiSMffn260vxyRV9MaaNpYoG2wxKMmQH83HuW9/1A9uvzUSra6uSxRcrAfVkc8hmI+UDHnaDge2d3WqRcs49dFI7g7gsmsgrJK14CgLTOFjEYyHU42bfrkYx1q3SmS4NHDQyPPJaY8VHuKggDdLkDyCMHPlVB9j1Zs1JMbXJdKmIGrgWVLfFvxJIMAyEDB5QEkDzljjx1XpzcFWjgoB6ErzI8ZQcs5OFVR5Ykn/Xk9D/AFeI66/ZTp5qrZUeggqb6AZZ5X/CQls4dmGZMAewTA/Vx4x1FW0FLTUpqqcvLBvAZN2TE5HCOR598H3+xBHW/rCKN5I4LAYf2fQs9POlOhHpzMxLsOSTG7cKR/lCn2zn6WhSK7S11b81PSwPPPTrgqyLjajnwcvsGPbOcgjrwNR2g14b/DkopQhh04/KO9GasuugLtQSUbwCC3whauGVCElkb5nCkfxjcVGPAXnjq9qrXWpu7GtrLZbXQmG2VFSkNHBASzzYI3eo3Hz4HK8YH1HPQDcvx93nnvqVjVELAhmlIU0rN/C2OAPoVHzfTPHWlol4aCludbE8sgVY6ZZS7J+8kJyVAORiNZOfPze3jqhj7tWi+lOZ+euauH96jjbjyTf0pSajpBchZ6cxViJurjvEixFnzy/hHz4UZ/4sdbmktP3m+m52VZKSi/usjVFRX1Ag9OJfnf1JG/IME/YlhjJ56GdHaxtOndMXy/VlfKlPWxJTwW9YiZHORyD+QIMYL/XAx7dDty1/V6ksV1uNbSwRU8lVT0MECgkCJQ8jAt5Y8Ic/0x1Qsc4nJxHkrB4aO/wRzeO5tk0lVXSm7Z1cUL1NMlFVXOnhYRjAGTAJPn85G84JB4A919QU91/YFzudZMkyVlZEPxBnDBiquzMxPI/MPPPWRHaov2fLOZZ1p5MOISP3xX7fVf8Aix49uiDTNZSy6IuVNU0MJpXuVOBERkYEUnO7zu5/NnPRWspePWorXr9kAvLv+pYUt10VWmqIYbClVAcAzFDUbTuzjyPpnn7/APTrdsAq30pTSJUJFDTVs4apLfIoZIzj6sTz8vnqnV2OFNLCEioeAVAmWAH9/tweP+X/AIsZ+3v1PZrjFUaKrqVqeFY6SugeONRhUVo3B+/O0c+SergmoEfG9fp1uVP/AJOFuuirV0ioKm1xfs0rRioLRyOy49Uqcjdj8oPHA461qWesisVrmrZBTxwxNA8hwTIY2YAJ/myrL44456yqelpJLHirWZRHKJUhPBYEe7fwg/fno40RXW+96Pu1kvtBBPHRVUdRGjLtMSOpUhD5TlR4+3VwLgR6Vv52t1RRWxL/AC66Ko3m7xtJQTU5FPFIqyKqDb844LHHluPPTbqbrab5SUd31EkclJVU6bApDTeqVw2w+wXkk/oOc9LSp0ZD+wYK+RJ6qho5srD4kwwO0N/wEjyPP263LDqKG56OnpLpQpJLaptyAAIohkJHGORtYAcc/Nz1LhUhrNNDxvw89/Ox4VFhV2uo/fy3eiIxZLvojXSVtkqjXUdLtX0UIR/wrDyq/wAXynOBznpx2jUtRc5Kehub0stdKA1EHUMZCgIWXPgFsDbnPI8dLOMJUWW2akjhqqiroYxHTxysAHB5jLkEE4wcLgbsDz0yu3lz07rzSS0l+o46K72afa1bTQJFPExYujsAACCchgff3HS026gq3Q8f43HjpdEjqRVxo7UcPP4+FBRVstfS1dmrT+04d5qaZpRl0kz88Z91Y+xHuPPt0StpK6aZt813pDBUVVRsFdCeZVixxEfZvqSPJx9Osus0NdrPcqzVzWt7lBJt2COMtAS3Luy5zwMceAecnHRSdRw3Uw1y+o8Ncvpuud2ScBk/UHBH6jpdzu0dVl2/PAj18Uw1pY3vfq+OIPVkpqulkmu1RG4L20oKhmmJAiKHhWJBIIJxz/CelxriY3OvqK8Q+jUxMS6qgG6PwcqODj3+vPT/ANe2e2yWJrdRsEuCq0csuPTchuVVx4IBAGfb28nKJstllvl+o6OvnaP8PMYqp9207FB4bP5W4xnwemopMzDKd2nh+/2QnsyuDBv18f2+6yaq1xUthoKFcwV/NbHJk/NvHCEHjG0L9+efPQXqOxw33TssaNJTTCpV6eRR/hSoD8hz5Q7jwfr7Yz0wdYUsdJcqk+vUG31MuY2kw0lM/wDDnGPbjjHH8uhy/wAgtVnSsmVqgQq0twWJN26M+JVA5bAAJ4yBz9evPaHMDZN+vLfX6ojHEOLmbtEo6ekqItLVNLLUxx1VPcoo4MpxIxikzDJnlWBAKEjzxk5B6xkq6i101v1DR0bmGJJaevpoTucRqcF4wfzKEkxjypG08Y6Z1wtMF90rX3PTk9LVetPA64O9axFjkGw/RgG4yM5A+3QEkE9ztNXUUtN6dZBUxVJTdgVO5GjJQ+BKNgDKThx9zg89iIjC6m73WnFIJBXegPvN27XXdgFHTVKRXO3OKmhk3ARTB1AUN7BZAFAccBwobGT1yfW01Xb1loK+GWnqaKZoZYpFKsjDyrD2IPXcK1EdTQwXZoZfw0JNDcFZAyxZA25XzteMgBgPMYBG4DKz7t9pqPW8FTcLEkceoqVUH5gqXCIf4TEn3ZcBXHGcK3kEDhlyWdoiOYHi2qWPbysqDpuEwRwIKaolikcogLA4b8zsAPYHAzjHX5qSraKqjqRdo6ielqtyLlvkQ+xG0L5x489D2hY1ga52i4WyoapikRjBIZFKOpOQVVSwYEY9vp79b2pY6n9nMRbaaniCgMxX05CUPygeo28jH056bcC5hHX2QrNeuptQaZ0roRtPUVBeKyavvETvNJGiPHcoCAYp5v3m4BtxURkkkAsWX8oKNAVdluVNeKKnoI6yK3R1waSamjleJSpRmRpSWVUYqyhWb5sY+hWuuai32jVVZZ6y3yyzW9obc8sE0QZ2poljbZ8xI2srDOQMjPAPWppPvPRaWtclpSLUM1K25I6ANAaXBO4OxLbmkztYjGzKLkHaD1wWTFQYcNj/ALj67zSxN9OA0Hlbd0xc0E10RP3b0bYta6HsGqv2mDUWWxra5qGFfUqppEnA3mEbWwAThdxypJyAuCotD2KzRUVXcq+oSqgodrrJU0zQpArMFBkiJYMTnCBOMnnIUg6mq9eW28242u3W2rtgeQvO/oQtIR5Cghht55J+nH1PWTQ3yjt9NFSU9ddNqxMZmalh3VE5OQz5c/Kh/Io8ADnPXQ4eRrR3j19FnzBz/wBI6+q1b5NZNTIqWq41NNQRxy1FDbpYMYJKqrEjyxyuc+fbJJ6zdPaFuDtcI4KwSTPEu+oCkxRQ7wZcYGTJgHjyOB79VZXqvTqqkVFeK2UxmGd6dV9Pk8nD5Y8rt5AG3jom0ZqWksun2sVTT3eYzj92YoIo1VAecAvuIz5JPgkcDpo4tpP6rJYYan+N+ua27kf2hRVNmipZY6SCkG1pU2AyIysoAPOAAw+5P2HQ/cK+32H0LdbEieWIh7hUj5jO2eYlz4jUcEDgn646sRzrTvJeFhqlimV6WAzMqmIujDJJOPl48fUdY9PZYIauM3apdoiBK5hXeCuRnJzn3HjPnrdg2lgWMyGQU4UOtFmSYLEuOZrL+SgenayNNUQELKXaOjkY+F8etn3wDhfuSf4eprZa2vtMtDQsv4uhG5ppMALSk/Ox+gjJ3efDHq5c0tt+npq1XrY1pqcU0gioyyYjOF2ksBwhXJI9s+/X5RV8VkCGiPpLIctmlL+umMFHO7JUgkH256v/AFXCvYCHjN5qpwM7XULTRZNRc6SGuFZSyOUoAEogrYEWDlWJ/icnLn2yT560qKJJoKjXUtQKcbRBGrIT6VU+QXQe6hQzL4AYgZ+Xqk1DptZnFJW1IpxIWiFRRMwQH6gN85Hjnjjx1djuFoiqiJLvWVdIYvQnp2t7ossZOSM7jg5wQQOCAR468/aWEpVr/wCOCq3BYitHN/lZ1BcYKB1/Z1HvEh9MrKN71CngqwH8J/yr/UnnrVutnorDp2WqpkqXhuVUpliON1OiDKQyOPGXLHI/NsHgg9QRVljoT6duNZGuMGVl/esv0yEOP0AHUhvVBTyiSJDNCYvQkp5ZJPTkjPJDgQc888cggEc9VftXCHvNf7363KW4DEDulvtZZMFfX/iKeCghVnZSPQRB6ZQ+VK+CpHnP659+i+Slt1n00kFDbvXqlnetq4jMJI6ZWVVQ4HMiABvmJwN2DnyQXUrVV2pFt1gusumsPveqoZqh5JhgjZITECV98fUDA63Ka4mCrS4jUlqpqmEKFkaiuEzHAwScbRzzkeDnobtr4YuqLU9fFXbs2YCh3+ngrkFRerhU0sNvilqauYFiqqD8p4wR+ULjjB4x0bXHStVZdJUX4Ggpnq5KmarMIbcA21EJjVvJG3gH6nGesCyaw/CJNAncHS1rFQhWQxaMrpAw+n5yQPPgce3W0L1pKvigpLl8QFjgSIYX0+3Nwfbn9ZBk9VftjDOoaEU5e915uzJ2ilQa9WQsjXOrjjSkSaWrllLcE7sjySfbH1Pjo4o5aa06WEbvRmvnrPVMuCYkYJt/LjBPJ+fGM+3v1XVu3E29an4oYIVfhvQ7XTs8mPG4vJz7eT1+VEPaeaJaV/itufoI2SsfbNYsfpyeoftvDvIJBt19OS8zZMzLVBqv5P2nLSyIElkq5JVK/NuaQ/UEef18dE9utVLBp27TVEtO1yD07PsUNGhBb82DhmGfPj9ehShl7Z0kjU0fxfaqpqVvAp9GqpwRzkFABz9Dz1sQ1nYyggkiX4wO4reoB6iw6VpVUj7gj79Q7bsMgGZptw/j0Vm7IlYatcPPr1VWkFS1NWRyPvd/nDht28/r/wBujTtvH+zluMdznp/xUtvd4qaRd2ChDqGOfJwcA5x79DdPWfDxDEGg+LfuVFLnk/2fo4/6D0j9vfqRZ/hxpw1VT/F93Ljlb/w7ZQq3PnkxDqH/AIghkGVzDbrgvM2NIw5g4VKYOiLst4rrhbp6yOT9p0zxiVssySL8yYUc5yMDHHPW72z07HdL8tJeZqemnuaS08CSRhjOwGVEi5Hyl1UAnnPP26S/o/D+g/GW/wCM/uNTVKnehWGhjcN+oUc+ffrRpNQdnKKZLi/xkd0qqaA70Zai1LJke4LRk/pz1Mv4gilZkyke/Lcoj2JJG7OHD4904dPSVdVcrhZLpV5WsYr6jNhoZR4BX7eOOP06YHaeqqTd6aku01JBNVyijDyrxUlWyASD4JUAOc7S2cHweXqPWvZ26Ty1Z+KLulHK2Sz1dXYld2OeSxgyerNPrLQBSL0Pix7lq9OcRFq3T8hX3yC0WfP36pNtyKVnZ5SPdXi2PJG/tMwK+jGjNVWu6V70MVSKWsYndTzOPUjkXjbt8Y8jj+g69aos9hp66naghp6S5zymRoBxE8m1gvjhHJ8HHPuPBHzqbuHa1qJKuH4xO6Ucs/DzH+z0jN9c4IJ/r1ZoO5NUR6M3xg93KsEhy5pdPSbj5zmR2Jx7c/bpF2Njc/M2oHXommYKRjCCQT6fyus7qau6RtRBfSuUDsiJI+DImeYyT5IP19sdYsmlKqltE+prcsJuFVCnrQSZDtEmQ6keOcoCeDx9s9c5y919P1VRJ+J+KvueapmDO09m0053/wCY+Dn7g56nj7txVCinb4r9eiKjUGF30tp9s5HzE5cEnIOTk5B56fO2GEjukUvp6eCWbsp7a94XTEutJTzOIxRyLTVTelJG3mFj7N9vfP8APoc1JQVdBVpFIgUIivR1CMGSSPGNpP1ByOffIPQbHcam8RlbV8XV5MTtuaObQVnaQAf8lSDj7Y6YA7M91INIx6quHei7zWJ1FSlTVds6YoEYfnPpVu5UIx82MYwT7Hq527hmvzOBA8D0FX+kzFuUEfVAVLpas0/Ya++6ToJvwc1yNTXUseGNKCiqSieWTdk49i23PjoLp5abVkl5ittC/wC0p6P15aKPPp1bRzJ++hOQUlGSCv5s49/LotllroKiOKi78aZMybwoqNEzqjBhh1cJWkFSPIPWFcOzGua+WoqrX3E7Pz+qjxSzSUV3oZQjY3cq8nPyr83PgdZ8+08K9hYwkCtQCDxTUezp2uzOFbceSTViJuRuNrppJ2r54DUxUpj/AHk8sOS4QY5cxmQPEQN2AQM5JrU1XDU25LhA9PU/suT5oWXmOCQlWDA87NzFSeR+8w3zKGLzpPh+7lG8UV8lunbG6VkR9SOSLUtZTSSMFOTuejOCQxHJ9/bqhV9g+6FDdaa/Uuk7FeKtQyyNbda20vU5Uq6lZ0i3blJDAg589JfmYnaFGGGlbqFzLrbtlbr7PPfLPUPSXGWnJEokylVEDwsoBGWUgruJ4I+Y4565/v8ABBBcZYbpar2a4uYdkqJThJBxt9NAxBH0z9/cHrv2PsD3WpIKwy9mtSwx1JEyigejrRTzjgvG1PUuyZXgjbtOACDgHpYdxOz1uqbjSVeqtN3C23u0bd0dRRzUpcAfKkgZBhDjIIyUIIBxwPDaLIbG4VxgnS30Kwf2dXXKpkrLhHHUzzCVnqn2tIF9Qt84G0D83JQjJHvjAsG2i3OsrU6mBo98WQrpIQcBlZRvx7+AePPnpa0veKgjiMVdbLo1NG3poYqinLL5J4aPP8wf5+MaUfeSjo4KWWx2ioq0qTJAW9X02Tbs3N+7A3Abhzz4Oc9ZXZyaELS7SM70cV2kZp6gRVD01NMibiiL8iLgEZIGSSP1OfPVSGGC0xmnraFmZG9QtvVXHgg4IyuVB4OQc9Yc3dyjjtk9LZNQxR1W5ZZqd6h2WCmBUtiYAjdu252A4B3HGOK8Or6W4x1d8Glr1WPIPXdqO5pVJvGPZAzZz9efP0692clLiyjNGDYouhqrS8LQPTVsxUxywxQojRA7SCN8hUAY8/KSxx4xnrUE9CrwyHTaRTMu5XNUCxYed2OBzjgnbjjk56T47q0hWWe56IuNPHu+WV5nXH/MhA+nsR/PrRl7mSU1oS9U9jiraaOf0FkguMjCMFASXBXMfJC4YAH2J6kxSD/H1UdozimfPca2sjiFwqYmZ1xuZEy0fIxn8/B44I49sdV5mq3qnmZqV3KAFto54/1/TwcdKJ++ME/yHSpAUjj8e64+hwFz/Lqei7yR1dRDSx6aCGaVYh/7xk43MB4x9+rdjKP8fZQZ4zYFNCqWepUSVDorOu07RtBH3A89ZxowMmNgx8n79aBvPp0hd1/Jkbd+eBx5x9ul9qLvGbReJ7NJpqnqBEyYkaoZTygPsPv+nHQ4nOlOVgUvaGCrijRKRX/KPPtjr0tGVLBgCSfp7dKhO/FPFndpenUDOGavkOT7gf16nTvYtRaJbvFpSBhFUrT7fxcxByjMW8+wUf16P2E4vl9QgdtFpm9CmgaEsuQn34XH+vX41AhTcR9D46V9P3nr6p1R9GUcUUrBTLJUThUBP5idwwAOev0d1al455abTNLLHCRGxSpnA+ZiFOC/vjP16nsZt7fUKO2i4+hTLW3AfNhOM4yOvLUTDAEUbZHOB46VH/tfrWpq+o/stToKFI2w0s5DbnC+d3HnPWdTd9aqeZaePS9Bvdtq5mm8n7lurCCf/t9Qo7WLj6FOd7ejIG9KMc8jHWfLRBZ1Ajj9vbpPN3+rMYGl6DHnHqS+f/i60X7t1v7Jnun9n7aPSeNdmZTncrnzu/4ep/LzDVvqFPax8fRNB6YhxhE8/TqOSKMqy7Iwf09+k6e+teYhL/Zy3g5K+ZP/AKutS196NS3q60VqoLVbImrphEkssTqqknAJCkkD9Mn9epOHmbct9V7tI+PomBJR+oSw45APAPUlNaldpC6qxwRwMdK+892r1QTxpWWSgaZ0bf8ANIBlZHTj5uR8mQfv1nDvXdo8lLBRc+SJJP8A6urCCYizfUKDLGN6bstrUOG9PIzg8dR/spBDv2HCkeR456VNF3kutfXwUklgoUE0qxlt8uRk+fzdQxd5blL8psVAoPvvlK/z+bj+nVvy82mX1XjJGN6a01pifj0fPuB1D+x0VCQFBxg8dKqXvNeIvlbT1GOf/El/9ev2fu3cIoaab+z9Awqoy7Zkl4Idlx+b/h/1692M3D1U52HemYbTHtKmFCD15isdOHzJTIM+D0toe6dU+G/YFBG33eUD/wDl1p2/uNXmnrKySwQyiniWRY4mlBfMiqcEk+N2eB14xytGiqJIyaVRvJYYT4gBHv1E2m6PeWakQ/qB0MS9ypobVSXZ9OZWqneExepIWi2+/wDxZ5Pt1+VncOrobjRUkViR1r4on9fL7Yw5IxtOfGPr1SknBXq3iilrFQKq7aOPA/4R1q0lhgrqNoEhp/VZljRXUAkscDHQJP3Cr5rtU2VLfTIaVHbf8xyUOCMDHt9+p7rrKrtFtjuL0EFSrSqhTeyAbs85yfcdRV4IFLle7pFQUc3HQ9RO9wrXsbyrSMn4t1j3CIsvG4gEDODyfoenNB8ctfpzQNJ2HqO25rJbjYam0xXSa9SGPLxNGsrRFScJjcU3YPC5C465psvc252taMUVe1FLdo8EtUSZO5ypVueVG739uOgLVusKqPWUDrQxLNYqqRFZZm2zjIHOfyggf69WGG7Zw7RtaVpdV7QNFimslkokX91SRjH/AAjx16NlgDBhSxYxjxjpc13dW8pQpXR0VLtM7QFd7sAQoIwQRnP6e3WcO8N8Y4NuosfdpP8A6upEMp3eqnOzim5HbIlwBARnj5X6uUFljqqxKdzIqsc7Uc7nHvg5xn9cZ6T6d1716EUppKCMSSOhJ9XCkAEeGzzno50NftS3+qAakt0rq42fh6rfHMu3JAO7hgce2eT9M9DlbJG0uNleMte6gTL/ALNU9gaK4W651bSElSPVIx9AcZHn+Rz17qb7famoRUqJoZIEzGjTOpxg4GSfbJ+XP1+/WHPqi8wSC1XS1ek0+5IDPIq7nH5owCcswx+b9OOob9WXu3QrXSxxxBTtmT02fGPyopyA2c+/36z2hzyMxqUy8tYLWCRcNspKWL1qqoqo4SQeV/eMOPlQfz8nj9fHVrUFxejtNst9uLQRVNPLUeiWBYhpXUEtwTkIDjgfQDrSr+12trhJUNKtPKJZQytLVcgD69er32q1hdJ6L00oESko4KYbqjklAS3ge7M3WzmjJBc5ZoDrgBDejdS01mv5vNwmqkSjQyItOc73A4jYHgqSBnPtnr01XbLjSwS0dUlmuMjB3Cu605UDHylAWjJJzg5HnGBx1qRdlNYMSGrLWoZsnM7f/T1dh7L6j2bai6WgMBtTDv8AKeOT8vPAI/n0UyRVqHKMr9KIKu9bPJVRQtcWqZAAJZY5WkBb6bj5x9uOtlbtcLPpa0T09XJFNUVtfIWD/mUCGPDDkMvDAggg9bw7G3yYEvfrYhLFsoHJ6wtZadq7SLPp2NpatqKCZmkgj4ZnnkPGTnwo/p1Zr2PIa0qC0tBqrdruukbvHDHdg9qngSVR+HgQ09RIw4JdmDRHPO0kpxxsyetLS+iLjS6p068v4orXV0AjWURj1FV1b5QhO77kEjPHJzgJptLagqgzQWW7PycBaZv+w6YvZ7TOsLbqygmWh1FTwxF3eP8ADSCLCoTgjBHOT/Q/XqZBlaS0qgoSAQnHVwSfsqaTawJDEjHv0h+4U0g1rc5BTkRiQwJIWyC0aLkY9h087idSVdsghFpvA2LtEaQtsJOMnBHHQLqvtfd73fauooqGVKWSrnmP4hnikdmbDYIjZQvHynPjnjPWZgh2biXJ7EkvaKJV1VTV8QG1rOsRwfThyct9cfXHH6db9krra2hqlqWgkillqJ0k3DcN6wL84HGOHHk+cn7dG3/sz1BSZnptLvLK5XKiuVBgA8ksoPv1Ys/Zytulje13OBbcsbzSBIK2BsqyxAsdxHI2D29+nZJWZbm1Uo1jqpaV0F0nt0VyuFxjSKupGemhByWRQVAJAOAMY8+fp1mU0t+qLdW/upqUyz0kMKCMgDLPjpy0nYey0YQm+MCE2gmupMlcbecZ60qTtPaKJif7RI/79akCS4RkBlDAcKvgbj/QdT+YZSnwoELwSUpbTQ3GSC72qYQpLDFSq8rqQHVp/wDEctjGPrxwPGehm701Fa77Qw224vWKzAySlAqOd5GY/J2ceWwfsOuhKLtRYaKse7Ralp/WlZGk3VZcMUJIyoi5GWP69Zh7H6AWRJJr2XaM5T+8VDFec+0X36kYlgJUNgcKVXN0JWaoip5HOyRwpYDlQT7Z6IFfOk7gUkDL+LplGRg4KTf+nTtTsd2vEi7bjIzg8KpqiwxznG0dFen/AIe+31TSKYmqJ6SY+pII1mdlKo2DguMMAWPPGAffHUSY2JoqURuFe80auc9FaBu+t7JfFscKzXC1U0dyEGT6k9Pv9NxGo/OwLKcDkgHrDe9arkrYklv9cZqeNKaJvxL5WOMgogIOdqkAgeBx467Ts3YHtzYJob5bq2sgrLdtFNVRsURQvIVg0gHIOefcfXrIu3w/9r5y1VDR3GpUerKxjUbhj3YGVcc+4GDn7dLDasLnmuiaOzZ2iq5Lvss1fDaKieVppaikdjJI7E8Ty+S3nrFMhAUlvJ5+nHjrsR+wPbTbDFNa7jsiiIAcxfJyDgZfxlifPByOs+Xs125oTI76XqYpKHaXjmliRkRsndgowxwc5+316M3acOgQjgJt4XNtu05d45bXqAUg/AzV0cQkVxw+/OCPPsefHWc1ZVCsMFYm7a5TJXB4J/r11imiu3cVLJQrYHjpIB+IjgeuSNRKwX5lUREbmxgHkfTB6pzaC7bUpzUaBZsozKzV6kF/OMiH7nkZ9vGevDaEZNSEN2z3uFHLla8XN6qM0wnl9KKUukTHhSwAYj9cD+nRnZr3LQT0Nyp6WKWWWgq6QCWIShtwC5wfcBiQfbppVlu7ZWxv7z2wot7EAK1a7FieQPliHOMf16rVGpO29mCrH28tsEkMrRj+8VRIOwMQNu3nHVnTtlFAEP8ALmEUqlZTVlLRQWmSloSFiba5aHDSlomXhjkMMj+vUFkvDSR3SjpQ+2GjqpIlPGCHRvY/Qe306Zh7hdvkjVR2/s7rEMxqyVrBT9h6ox59usmW+6bnq6qKz2elppfSeTbDSsoQMmdoYnOMEeST14E72qKN1zLADmLR8Myq+Ybgqkk5O10b6Hn29+qupJWipNOXGWV1BpwVXOFLrKM5H6H26NaTXdZFp+4xUXbbT7yU1REsfqU1ZI8wJA3Emb7+3HVev7hXyo0vRT02gdMpVwySxvD+whIU+YD+MseRzz9OpbWtab/dTQHehq4GNe48lvig9ISRy78AAO0kG4MT5J/Xj6dWL5C50hPMCrNGscg55yHX/tnreuWvNXjUVBUU1hsa07xwmWVdPUZZMrhssYjjH+g60qzXGsY7dVrbqugjcK4iWK10ajdj5flEOOhuBq08KIgc2hCU1YqzadsldJLseBp4j83zZDhh/wB/OOrV405dtQ6xe1WK3msrK8pNCiOoMmYdzYJIAwFY5J9ui99d91BZCj3qaCrNTuwsFPF8hU5OAgHn+fVin7partd6tF4v11uN1tdEIpLjRfjEHqbchlwTjOCCOMcdHYSDUc0MlpseSXtZp+72y33Ww3S01MFfb6+JpKdl3urFCD+Xg+x4+vVGn01e3hBj0xcppd2TihlPH/w9Mq+907/fNQVt7sN+v1rs1WYfwtHJdWzEQqhvljYAAkMfHv17re42pITCn7Zr6kPEDk3ObyCePJ6nM5m5SchNjogam0pexRS09Zpa77hLHIqrQSqcFSG8pjPjo3sFmenpDHS2nUNDUt+WoFFUSNhcEKRuJCcc425wOvyLXl3qUkD1NwAC7j/epm98cZIyeepKbWVyZ9g/ahSUBTh3OQfY5bx0vKXPCswtabIius2uLp+EjpZKyoggbY0klIyMx4IILJuycnkD29yM9VaW1X+hYy1FHqGrjmOwxwRysMH+LgZ4IxnHVmhvD1aIpqJwiookRvWxkDjHAwM+OT56pVN7udNU5paK5s0ZPzLLLg/TGWzjpJgI7oHwmHEG6tVHdy60Dx08tgtcbu7hswRZUAgD+Aj3PH289Xbn3VmpI6haSW1y1ELlFiWjiG4hsHkR4HHPQ/V32vqFWT9m24yMpDlqbPOSS3LdVBebzHkxx0MYOMKtEhGfHvn79F7p3KpDxvRLUd1r44tiWd6WapqZBHUR/hAvplmUJ/uwOcn+nWYe82tjNhJVT99hlSmJAT6ggYz9uqseor/HOkqVNOhQhgy0UQ2kf+XqI194D7hURqSQSVpIfp/ydXBYNyrR/FFVD3E1dc6yIy3eqgolhZ5JBvj/AHm4AKCD9CT/AC6oXC/aquM8P7M1HeJGeQxD0ql/mIVOPP1f/r15tFs1/fcw2O5yTYRZHWKeJPTBIHzgAFQCeTjH36aGj9M1GlZaqrul7ivkq0oaKOepRE9c5JADkGNAwXLsvnAOBhulcRimwNJaKngqu4EpYpZ+5sJkkrrtqCoWKQr6CVjl2YFgflLbsDYT4HGD9OtiyWjVJusFNd7ZcKPMM7maruBO0GFyCyff2z4yCOnra9VU1XUV1VXm2VcskDQQUssgcn0xsJZuBJgK7BgNwwcE4BN+tsGldTrNbJTaaWnlmlgpFmTfJUll/wATZuV2Ckn5cADZkAe+GdtYgPySx24g/G/5UNaBeqQlZLK6eqlolCSIkaxKjbvOS2ccnwOvNttuorrcPwtLpCOmNS4YyStJuRS+PATyWbgY5Jx9+nLRdvO2FhSopZtKy3CpmljljoSzokVQqMVWOXOArMhXLNk4xuHGNuGrhgqrxcrFNJfq9aRZZYLfVRiqibeQMQnJJVpTjcpzjCk55vNtckFkUZ8Tb79cd1udVzhq/SmqbOBNYmSmpfXnhKzvB6oZZWUAj2OB4ycbTz4za7e3DUa1KUVXsqJIi4CLJGnqozKJFUggb1wGwTzgdO/UXb7T+qKmG9ypPE1PToaxKp2Zl2KYTKYtoRmSVNjqmdrEHJyMAdH2zWxXa7VkcEotcZJgt0ZyJ5RjcF3gEEABWLYXB8EgdVZtQSwGCT9XHTy8ael7KlDVAd30ZqqjmaoTUFO1M0kg/EG5gRk+o5xndgHHleSMY6yP2Td5JfR/tHSPg84uG7PsMYbPv466Fr7Xp+5RxreKOEvR1Mpal9ItFDUuEBdyMckguRg8cnaTtOfZO09Fep/2NSXyotMlSyrcEkthrqWeYPtWRVE0bJtyQMHP8uOnsHtJ0wyvbQjf0fZHbHn0STax+nRNSz6ptqSs5LF6iU7MEAL45zz/AE6tWPRdrkZaqv1RQ1EUEgeWKNZyZIiCuVIXkhvYfT9eujarsf2L0jdpaO6d8LdS3GhlMVRDUwUiODzkOJavcr8geBx7dQWftJ2UrpZTbe7DXaenkpZVit1PSy8ySiNAP7wQRvkGfp79MSYl2UhoRGwVN0ubJ2lsVP8AsyspdQL6kk+2IrG0Zk4RiMsMjKhhlhjAx5B6a1rp6DS0ElvpZEnidVkJkLYi45RkHsAcHOc7vpwK1/uHw8aNuVVpu591ZaesoKuVKmnqDRo0U3upUZZSM+3889V7TS6JvVkud30fr97xDa44mqY/SQn03bCjfx5IIB5+n36RmbM5uZ5NFpRPijs0XXiqvVHS1DU9FBTU7SSJHxFvJQpnI8jYASMHkYPXmtuFvlpZaaOn9eGcKkpLNhyADs5Ixxls/qOhgRzvPSyQ1m1TKzqDgCQK35twydwC7fPv1DXXGKihjlhZmjmkeR1PztyBtJycL+Ycc/8AquW0pRMiYnVass1IxknqQqJTmOUyKwKv8/ycEnleCfrz5PUFHfaSnBgqLeFiqYpI0YgsSpVgc55J4A5HHke+R2/XakhpW3GKMtIkJSTAjfH+QjPy8ZyPuB9qy07iKGViufQVKn03OdrKdgP6nOMex6ZijzNuqOmobLRnNI9NEiykbfSAJxtKqxBJznjnOR5wc+DmGa8SVcm+qgkljZQIykiq0kmwqCxAwM48jGSOehi/GpoamKjYylKxY5XeQYUqXILLkYJJjIz9Q2eR0LLqyg1H3Vt1mpv2r+FtTvb6WKiB9KepIK4YLyRvwAD+bHtnp1uHLm1G5AdOAaHej+4261z+nHtDlykjAvtDykqMNx7EfUHg46xr9py3XGlqaqqtVMjh1ljjeRgP8m4bV/LhvJJOQM9F0Wgdf+jLHS6KvrhZCkS/s2b5XJ/Mfk8AE/N+uOiq2du9dx+mKnRt+nKgKqmjcAD/AMw4GPY/X69CMpiuCp7Ns1nBc233TFVZo2qYbNRSqGypVpMMhHBxnI5+/Xim/DII6+u0bR1LFdrKtVURM20YxlWz4HT31PpKvoIjSajono5QgDwS7fWCkBs7Aec84JxkqfcHoA1hbFo9IU9dTLT3GUUcV4pxDKDGaSKTDNMSQVXf8rBsNlCCDg9OQYmWajQKlIzYSKMk1ACF4+4unk5o+0lFLsUK7z3yvY/TPyuvn6dRNr+iVxFTdn9LiprJBHAPWuEzyP8AQAznd48Y6Z2ge2Uncu31V20zbrfmKpAqVkljgKMVBACls7eOMDjB+/Wvc+zFZpd44qmhgluFVHLPSJTyrUGNEXMpAXyQOf0HHTWGBxeJ/KNs+9i47hVUkgMMX5h12cQOdEjm1dNK7AdtNFQNHner2+ZihHBBDSnn9er1t1pq65mqltXb7QimijDOyaep3bYASTiRiWwAScA4A9h0x+8Gk9G0NJpTWtsoGsNHrCCq/aDGSSemjnilWJ6lN53ojl9zoC23ll4+UIyXUdpsmrqmFrjSVFNbp2hE9CkubjEGB/dl8NGzDKq4AHjcpHPTUmFdHI6F47w51SjJGOAcDY8kVVXdjWkdMBBQ6TgccExaZoQQfsfT69Umodd6ymp9KTXW2wQ3t1oZDFZqKPasvysfljB4BPgg/Qg9MOyfDrTa6s4v2n9e2+GhqGYKlRRSNUQEY/dyhCVDjjODj/p1h6y0QnafU9ipavVAy0sFQLnHRH06Y79qyGMtllRwN4yDggj6dZ7J8O6Tsm0zDdS/smpcLiI4u2eDk47rq1dtCas7Z9uRNYu5ddOtrnjiSlNlgiVYJJGBf1CWbcGI4Ps3ngdLOr7g9y2kjQ61uIQg4CrGvn9FB66rre1l81JZhp+7d1LXMlXk1UlNaZc1QV9wYKZSAFIHIz98Z6DKr4atApPTpXd56dGZlWILb41MhPAADTZOehHaODza1/4n7JgbKxtLt/8AsPuufLrqvX06zr/a+7OFT/8AcEbh7g4/TrIFw1PUem5v1yLEgkmrf9c+et7VkEWmtQ3KxVSMr000sA9Uhc7WKnJ49wf/ALdNTR/bPstcdMW+93/uDX2WomjImoKuWljkp3RtrKSwyVyOHIAIIPv0zJMyBgeRY8BX2ScEMmIkMbdRxIGniUioKu+Sy/iay+XLIZkZvXdyQR7gnrVo5oaqZYqyuqZFjO1txcsFPuFZyMA9dEVPZrsBbJ/wVbqq/wA1SyLOYUmRiyHJDqIoWJX5Tz44PSd7t2fQ+lrnb7poGrars1zpA8MrzGR5HDEPkkDlTjIwCAwyMjJXjxTMS/KwH6UCZnwUuGZneR5EEphVt00heahYNe6Nk0pWHc4rrNQ+hHgn/eUT4BHOMxFTx4PWffO11/s9PU3GhSmvVuhO6SstzGYQgjIE0eBJCcEZ3qB9z19PdYdtdHdwtFSSa10/R3aCuqRKyzj1HiDMuSjn5l+UN4IOOlde/hjtNFFSai0c9LZrksf4uWrakQzMzKpOZcj5VG7AI5B5JwOsc7TDBXKU2cKTpdfOqrpBBN+5iZopohJEcZyCPt9wR/I9eae219dWLR09HM9TIRGkQjO5mPgAec9do6q7WdrdVS1ddq+htNPT0xkrKiNKFoXeJXwzCRXRskHICg5JyQCesm6W/sTTmjorHT2COsj3UqTtAGqIsEBzlpAN+0rgNny2DkY6H/X4LtDTUckm6KNlczwOuSRGnWl0NCs1UthmeSnkrEesbDRqEDlPcOW2MGUgAbT82cdafa3upa9S66rErdN2mroL7RVU8UtRM6JQzNCxYRuzEwvuLbct6UpZd6qV6Gu7WmrTd7XfP2BHqu7zQwvT2+GhsfqUhbduIEsSFcZZm44Gcbic9L3sFd5dOako9R3WOhmpbJ6pqqd55EmjgEb/ADvEP8RFZsn5WIH5hjrWweHGOgfK0EupYUpurvSIma1+bdzT3st9skFgpLZT2mrqYHkkqai73ERpPJkpEm1IHb1JVJ3AMFO0McnBJnu66luvbuvvb0l7nD3CpMF8RGm/FAE8tLHG5JBEu4uFXEnzE42h/wBv7P3GotKXeiuGkaKmr6UV4p1pqioT0Zow77YhGFiJTA2liAckbetTQ3ZezVlNQ3eC5VlGtXQ+i0VBb0pZHUZYYkMjmMAsSEVeDnLNk5512IDjmdGRQ11GqLHhp5NGmn0XJVh1pqeM0rVAq5JnrTDDT1aiC42z/DSKUb9omQq+QAMblcsVOSb1N3CvNFVU14ngpo6+31UqgVEUn7+FVO2ISKrO+1vyqx3IGC7hx10zqvTestG0O+bQ0OuLFBuMsl0qaetr6eJG3gq0sCSnYdxCiTjJ89K79kdrL7qMUn7av+nq2uCvV2avqWp4pGZMjcjbVkAUYI3NkkjGAB0y0CSrsop19EV2AkaaVXmaprdX2a2Wv+1Vujo4rbGGmqa6Gi3RzSSzvHEGw4UBhkFQDwOszXNZDp9Hu9XqGlgWj9UQusUiNNPHIpTaRhXXYWBXnGFGcY6CO4ljtz32ragoIFZKp46dqb5V2B9gUKfC/LjA8cfzb/xDaVsq9kJ7LVRNU36hMlZQQ0+GmaSGWFZGwPMbRzckcfKfpjq8uGYS2p18OSYMERhcad5o1qljBqigbUNqlo71VR09VcGp/ThqHkZgAoK+mXKkDeUPAywIG7HT10bNaaXUdIszmCP8VEJPWhdMEuAfK9KLTGmbTarDZqq5Ucs14eQOgip9y0oJOC7/AO8kII+cAKAGAyc9dH6CmFRq61ASNvFfB7/Rx9P06jD5aGm6y9BA+MVdvXOfej4M9Ja+7j6l7jz98KSmXUd0mrY6SO07zFvIxHvMnzEeM4HPt1e7adgNKdlLnbZ7V3BrtS1Nwu9thelW0lfw6LUhi2YyxOTgYwOempq2TUOspoaAIauC0tXSUscdA1RIEaYyECOIq0hLyEkluBx9B1Ho7TVzhuGlL7XU0UMVdfqGkkjDYeKoSRHkQoSWGAV8584ySD1rOmlfGAT3fJQImB1aX80vu4Pwc9re5et9U9xY9S9wqlq66T1lbFQWT91TOzFmjy0eRtH156lt3bbS3aLtpre3aFm1NUV0kdvEhvcca/hts6GPei7XUPvIAwTyDx10F2zqNZVFfqWisWsP2BaaerNZXTshKb5HaMZKwyHBAPGVAAyDnpc6ooXqO3esL7eNQJWT3pqWOpeVmaoiWKtiQSS8ZYMp+U+TsYYGOj4iJzcEyZz6g1AHChGtvk80CGQOxLoQyhFL8a8L/ASd7b6+t2nO4FBXazpaa3WK9UlRSXKK5IksMNRCBNGIVKMXfJZBtBdg5GDjjorSute0+r6KsrNKUdgmFFVSUlVGbNTwT08y4yJIZacOmcggsADzjwccS90tWXfR94sV301GgudBWvX0tUiFgPTgwXABwdvqMcnJ+vRv2O7i2aq09cKjVFu1R+3bleZHqJLbforZHM8xebc4NNJISAHJJbG0jaByTkT4J08AlaaUFBfmd1PlaGD2jHhMSYHtzVNTav8AiNDXlwXTmou5ujNM19psz6fNbVXcTilitdlpaiV2hCEqI0iGBhydzFFAU8nPX9ofu7Yte2qrrdPU1dSz2+rmoK2kqKFIpaeWNymNyfu2BwcFGbGCDg8HlXWXevR6wPc7Joq+ftinaSCkrKvXFfVuq+ooZSkcUa7TkMV+XIHDdCmie6b2q1jT9Z2603e6kmWrSpulXcHP72Qt6fpx1UcRAJY52lzu+YsehjZRdDUmjuNed7V4UCfO12snGVnd4UHAU9an0RF8ROpjF3ZvMMdPJUyU8YrGgkVVjiilp1ZiZGJ/3nqEJj/eEjzjrnTS93h0Zrekaz3yqiooGWuqJEoQ01IwQlkaJmCyei3I+YA7Qw2ngM3WuvtRaura7S1k0H25sUrzRU7z2y0PBVy70z/imR2b823by3PHjPS2gpWGpaS4T11PJUVLI9TT7BnDfu2UjkEMuSR5wfHv102CjEUQa+9gPGy5bHYl3bF0VhVx8LrpSj+O2y/syitdJYrnJdfwKRvUVcqtCaxRgrudmYo+3/EYEgvyDjlj2fvvebhq2osV3t1mq6B7bFXLVWf8VMaWRpHX02QxlqgFVHzKECkg8+OuHodEWyLXotrh5rPMss0R3AN6fIAP0w3+mD9emZom963hvjpBV6naq2MgudLcpo6moo3OYY39IZKgryN207QcZHKGJ2Zg6Exilvfx4LZi2vjQRmNaEen3TX721utLpqmivGmNK6hSkW3iOtuEtgrY4oSkrMv+JGqOSrEcngfz65qvWqairqrYvpx0FdSD1ZJWf1IKxpZmcvJG+VC4bDRAFCVY45I6NtX0HcO9XuPT10GtqppbdLMtLJWzlyRKgaR2chcbTg7sgFl6D67SVNSPVFraJ4LfPPDI0lWEnDbMrHtY5YqWyfqTgE8ZcwMTYIgNaLL2hPJPMXixJ9afsibS3cfWOk7xclplp9IzxKklzb8KGh9ISBwI1U7M5J2rtYEMQCBx1+a97v8Ad+XUttrtPajvlQ9Eiz08oiXdDOXOXiKIu0ECPgHjP360qPTWnbzYlo3aQVM1EInNPA8hy8YxuEak/m5wet/s3pyr1Ppn8DW6rsFJcaKea3Sx17TNOmxwq7Y1RmDEDHj2HIOR1d+KDD27GUc00rv0pqpjDns7MuOU3pW3HRYd67mav+Imu0poq5zVyatt9BJaaKiigioqeSpMzzldhKRq77mJLAbiFBBznpQ3Ck1HZtW3WkuNBLa7wJJqZ6RqIU4jkbKsjRMAEBG7jAxkYxgddJ2P4V+5d67v3l5bhZaH1oZ6qGWrnMLVbKiemtOr7XEhZiMDDKEZsMvB2r98InxA6ytdBrK6091q9S1EVMaqG71FKiFofTTYzmbcNqRgA7fmA8DOevDGMjNS4d7id5Q5YJJTUA24DguWdPXy+6eWagmovxFFWh4JKWUMEJddu5CRhZRwQ32GQR04+4k+i7pZLDQ3u8a1rIaW3VPpU1PbI1kiCojSCSSesZ3EeFIOMHAwOMdNq9/BL3g1HZ5qWmjoIpI4mmghlr42YzKPkGVYjJPy58ANk9alv+BPuPrC322o1DqQ2Gpp45YHpKmlcykOiq6s8UjK6krkENzxke3SsmLhe5shdQiunhZMxwTMa5gFQfuuVNAa1tsGrNP0v7CcUcFwldJItkVSsjqAjAtujVhhCeMHnOeMNjUVLTXSyJQWm1mOCWsSrq2rWpJjOVn9R1Yx0yFiWJzliAD4x09dMf7MiKzyxyXTupbKmNaqlqgZqSSOeMxvl1BEmMOvyHIYjgjB6YL/AAJ2povSqu7V3q6XdvMdElNGF4wMBo/oefqel8VioXva+I/UFTh4cSxhjcKA8wuD9b1NpvdTcoLBoeKC4VtxkofxlXqL1JDIiRL/AIPooNuGRQB75446ExfNXQUdbbLDcKOkobvVCOa3oFjZpRHEWyD/AAg7QOcfKeOvpHZvgU7O6fllrJKu/XSWsG6Z52VmkO0Dnai48Dge/Vi3fBJ2HttR69Lp68KzoUlDVMjiZefz+5IDY9uAM569Hjo2NykVp1v4bvhS/BTvfmrQny9vVcTUOsrnU2Clrbdo2io2uES0itG91qXlkGVVEU1BTGSfl2kKScDHQteq7U1ALdpezads1TXfgijGq04tXVKy7SYxLIpLMAc5AUBQvX0w018L3Y+x22mtP9nrhJRURzBHJcKs7MEkYBlCjBJxx4PRlTdlOyMYE9p7W00syfnlZo5XI8EfMpYcdLNxTI5C4A04W8vojuwkzwMzr0onDVdsrvVWVrRHd6OMszH1djYJZXH/APYf069XntnVXalqKIX96Vfwhp4fQyq7mVhub3YDK/LwOD9emMJ45d6yyL838QAH+mep1e2xg4nwQOcE9CZhYQaj1UvxEhFD6JMRfDtpit0y+l9URUV6pHct6M1O6xYLl8fmDY55AIzjnPVqh7AaKskUcWlNP6UsIhJCG32GmVwM5I3sC/J5/N011NpLmQlpPqW3HPU5q6DgLGFz9gOOpbhISNfUqrp3Vrl9AlfP2rapDfi9c3F8E7EO5gv0AUtjj9Oub3/2V/aSvFDU3HW2oZqyluMlbLULS0sT1EbqoNO5IPyZDHI5y7ddtMtBM+WlJwflVAepGmtVIhkmlSJR/E74H8ycdM4eIYc5ozTzQ5n9qKPFfJL1uy+m543pnulSoljaIpGUAVSpXAwvGBjH6dS0PYnR1DbKe2LPcHp6RQqL6irkbs88c/T9OiOt1foq3lzW6ltkRHPzVKkkfXAJ9+sk92NEs/p0F0kr3B/JTW6SQ/bnA6o3CwN/wCs6aV2hKpVnZDQtdbK20NT1sEVQDG5jqApwUCnGBgHbxnH389CmtfhZ7XazpoKG50lYYKdGjXY0UjnC4AMkiMycE4C46N4e4ssm97PozUdbvbdlaZIkOf8AiY9fi641ZVOTTaI9MAEA1VwjTB/RV/79WyxDvb1AMmg0XFur/hL7faWuV3s9DbrzTRQMslva5171KmIYb1EaLax3EMSGDBfHGOsW1aKvtPXy3C73Y364LO8i1lVBFEIEkb1JxGy5/d+ooAVVAwFLddr3yfV2o7dLa6u26cgEiMscjo1S0RIxuUMpUkfcY6Rl+7Fd/Zjt0x3M0qYJSWzUacMEsYycD5VdWxk4wB1l4jCPxLiO0FDxr9LJkdiQM7DUcD6pCai13fbbazQVvbe/22CqZUjqgsMsBiYjMkrISyKpOcEggkZGeOiTspc6Ss1ZapTIHEdUGPP0yfPWvfPgr+InV1HUW++d96KKlqcmaKktcsauccFwipvxx5+g+nVntr8DHczt9XJX0/xGUUrQgq8FXpdqrY5XB/3yN/FkZz5HTOHwcWDiLWuFT4/KEHd8UBpz/ZZmnr/DQ26rpxabLcKW7Q7Z47pQxVSHa24bVkyAc85+w+nWStVCvcbSAUwgm7wusUAGAAysQqDgDjgDH06etF8M149FqO5d4a+FYzsaO2WC2W1fA/LvSZwMYwc+OpKn4Ru3twraK6X3XWtK+ttsgmpZG1S1OEcDjApo0wMfTogO4myMXClkhLBWa3opa6axG+UC1jGR3oxPTmRCWIDbMZxk+fqeoqvRt7vmitWabt1nvE91uNPRSJBSUxlqJ/TqN7naeTx5PtnPJ66cT4Z+xbOGutiFzkA5kud6udcT/J5dvt9OiXRXa7tnoCuqKvR2n7NZXqovRne2URhknjByqNJtzjODzkZ56gitqquaxovlxrXsL3Z1frC10Vv7Z6zSntsU6V862Rklj9XYVVN52fwEBscDyCeiTtz8MnxCfiqyqXt1UU8kFZJDHJcZI6JJMQBEl2sTkFW52/LuDAHr6rwWTTdfFvgNTvBy0MlTwD98eP1Geq1ztelqaURS0dVTEDIAZSGGfILMf9Ojtlc2MRgCnn48kp2LXSCQk1/ai+Xy/wCz87t3Rnpro9mpEljGZpbxG4UllJwY1Jz8nPHv9ejG0f7PLWkMO6XUenHOzcsyT1UioQSR8ioucZxjPOB19CP/AMJhQyUc5KjA/eIMn+QPXsxafrpY2ZK1GXhf7xg4/UD/AKdeM0hFKhHyMrW6+d9m/wBnFTwVVyrL/wBxaeWpqyjbqKh9IxFQMlQ4bYSQD8uCCAc8DrdtX+zh0T+Eoxfdc6lrqmlkSR5aWCOKORkbKsVaJzuI4Y7uecYHHX0PjptNUUHq1aU82PAZfVl/+LAJ6yrnquKT9xZGgR/CpWRFc/TBU4/qD1czzAXeh9jC912dFcbUX+zs7TUNZFdYX196vpmF5RcQQ8W/eyMnpj5SceCD9MHnph0Xwn9sLRThYdPxlsj5Hr5fUIx4IeTnpu3TU2qItxuEEMKhsbxAvpn/AM3I/r1mR3+6iTGyklPJI/DRk4/kOgOke/VxTDWNGgCXtD2I7fWirSro9BUdNUxkhKiakjDAHz8zAg+B0TUOgdB2WKaeOkslHVzssjmkoot0jAYBYxoMnHHPgDoug1Rd0VpJbbStHtALtCxBGeOANvWrHf7K65u2l5FfGfUo43iP/YdUN7Eq1aaBLmKy6To3eWmtEkbytmR6aFUEh/zN8uSf1PUlPaLZFUGotVrpvXlwHdaZoZX+gZwvzfzbpkSX6wwLvoKWUEj8tfvGB9yGIH9OqLatZFKnTVJsXjeKgMp/rx/06oabirBx1AQXJQ3KNgz2NpUB3YEZlC/fjOD/AE6iQVqOUj042M5AIZCP/mH+o6NYtbxR/NDa6KJl5UxViqyj+XV9Nc1FdJ6QissmB/8AqgzjH/MF6ijDqpzSbggGW33JyJpqJKcAZy7wHH9T1/QxTMwY6hpYSc7lKKP6kZH8+iy73KyTkrXNY4JD/DTPJIR/Ipj+XQ/USWoSZp54XzwQlE8YU+Prjz9OhlzQrtqQpTb4WjV4bs1RKBkqoR+fsArdZ8lLcJn9L1sewASVD/QKP+nV6nuVTCcU9UiDnxTjAA++c56sV+uq+3hY3uks4Y4EcsIIJ/Rs9UzhWykLMXTNa0fqehdznj92sm3/AOYdeRpO9RkyMtdCoyd0hA//ALdRz62vdQ3qCZ4/+GPEOft8pHt1FLDX3ONXlU/M24tMXlxxxj26nO5SBVfhoKWGmernrgY1yW9TYGwPfBUnH36r096oKGcwRQRevySrShXwPJKjBxyPbqjf9LQ3mg/A3VXnjD7w9PVyUz5xgAlGGRgng/XnPWbS2Ky2cyS0aTwSTN88yJBJIePBkKhyOM8knJPPQ3OfXkocSDYL/9k=`,
      title: "Photo",
      sharePhoto: true,
      uploadPhoto: false,
      isDataUrl: false
    };

    let navParams: INavParams = {
      view: {
        fullScreen: false,
        transparent: false,
        large: false,
        addToStack: true,
        frame: false
      },
      params: params
    };

    this.uiext.showCustomModal(null, PhotoFrameViewComponent, navParams).then(() => {
    }).catch((err: Error) => {
      console.error(err);
    });

  }

  scanQR() {
    this.qrSecurity.scanQRResult(true, "Scan QR code", null).then(async (data: IScanQRResultString) => {
      console.log("scan QR code result: ", data);
      if (data) {
        if (data.code.indexOf("https://")) {
          let res: number = await this.uiext.showAlert(Messages.msg.QRCodeOpenLink.before.msg, Messages.msg.QRCodeOpenLink.before.sub, 2, null, true);
          if (res === EAlertButtonCodes.ok) {
            // open link
            Util.openURLAdaptive(data.code);
          }
        }
      }
    }).catch((err: Error) => {
      console.error(err);
      this.uiext.showRewardPopupNoAction("Error", ErrorMessage.parse(err, "QR scan"), null, false);
    });
  }

  openAVFrame(record: boolean) {
    let modalParams: IAVFrameNavParams = {
      title: "AV Recording",
      description: "Record video from webcam",
      videoUrl: ApiDef.mainServerURL + "/media/user/video-stream?file=video_raw_1675339011402.webm",
      context: {
        storyId: 1,
        storyLocationId: 1,
        file: "test.webm"
      }
    };

    if (record) {
      modalParams.videoUrl = null;
    }

    let navParams: INavParams = {
      view: {
        fullScreen: false,
        transparent: false,
        large: true,
        addToStack: false,
        frame: false
      },
      params: modalParams
    };

    // not added to stack = cannot dismiss
    this.uiext.showCustomModal(null, AvRecordingFrameComponent, navParams).then(() => {
      console.log("returned from update app modal");
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  openAudioFrame(record: boolean) {
    let modalParams: IAudioFrameNavParams = {
      title: "Audio Recording",
      description: "Record audio from microphone",
      audioUrl: ApiDef.mainServerURL + "/media/user/audio-stream?file=audio_raw_1675418735796.webm",
      context: {
        storyId: 1,
        storyLocationId: 1,
        file: "test.webm"
      }
    };

    if (record) {
      modalParams.audioUrl = null;
    }

    let navParams: INavParams = {
      view: {
        fullScreen: false,
        transparent: false,
        large: true,
        addToStack: false,
        frame: false
      },
      params: modalParams
    };

    // not added to stack = cannot dismiss
    this.uiext.showCustomModal(null, AudioRecordingFrameComponent, navParams).then(() => {
      console.log("returned from update app modal");
    }).catch((err: Error) => {
      console.error(err);
    });
  }



  testViewTreasure() {
    this.placesData.loadTreasure(60662).then((item: ILeplaceTreasure) => {
      let itemFoundParams: IItemFound = {
        infoHTML: "<p>You have found a story crate with unique content</p>",
        shareMessage: null,
        amount: 0,
        opened: false,
        xp: 0,
        title: item ? item.spec.dispName : "Story Crate",
        item: item,
        place: item.place,
        previewCallback: null,
        inputObservable: null,
        withDismissOptions: false
      };

      if (item.treasureContent && item.treasureContent.description) {
        itemFoundParams.infoHTML += item.treasureContent.description;
      }

      itemFoundParams.infoHTML += "<p>Tap the button to continue</p>";
      this.modularViews.getItemFoundView(itemFoundParams).then((res: ITreasureFoundReturnData) => {

      }).catch((err: Error) => {
        console.error(err);
      });
    }).catch((err: Error) => {
      console.error(err);
    });
  }


  testDismissWidgets() {
    this.uiext.showAlertNoAction("test", "test");
    setTimeout(() => {
      this.uiext.showAlertNoAction("test2", "test2");
      setTimeout(() => {
        this.uiext.dismissAllWidgets();
      }, 3000);
    }, 1000);
  }

  ngOnDestroy() {
    this.clearWatch();
    this.messageQ.cleanup();
  }

  testTransparentPopup() {
    PromiseUtils.wrapNoAction(this.uiext.showRewardPopupQueue("+10 XP", "discovered place", null, true), true);
  }

  testTransparentPopupLongImg() {
    PromiseUtils.wrapNoAction(this.uiext.showRewardPopupQueue("Got it!", "<p><img src='https://s3.eu-central-1.amazonaws.com/leplace-storage/editor/user/user_25_urban_escape_game_1_place_2_quest_opt_0_1685198311087.jpg' class='border-radius img-small'></p><p><img src='https://s3.eu-central-1.amazonaws.com/leplace-storage/editor/user/user_25_urban_escape_game_1_place_2_quest_opt_2_1685198328849.jpg' class='border-radius img-small'></p><p><img src='https://s3.eu-central-1.amazonaws.com/leplace-storage/editor/user/user_25_urban_escape_game_1_place_2_quest_opt_4_1685198356340.jpg' class='border-radius img-small'></p><p><img src='https://s3.eu-central-1.amazonaws.com/leplace-storage/editor/user/user_25_urban_escape_game_1_place_2_quest_opt_6_1685198612369.jpg' class='border-radius img-small'></p>", null, true, 30000), true);
  }

  checkUserStatsChanged() {
    this.rewardModals.checkUserStatsChanged(true, true).then((res: IUserStatsChangedResult) => {
      console.log("stats changed results: ", res);
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  onSelect() {
    console.log("onselect");
  }

  testAds(mode: number) {
    switch (mode) {
      case 0:
        this.adService.showBanner();
        break;
      case 1:
        this.adService.showInterstitial().then((data) => {
          console.log(data);
        }).catch((err: Error) => {
          console.error(err);
        });
        break;
      case 2:
        this.adService.showRewardVideo(true, true).then((reward: boolean) => {
          if (reward) {
            this.uiext.showAlertNoAction("Test", "Reward issued");
          }
        }).catch((err: Error) => {
          console.error(err);
        });
        break;
    }
  }

  testAudio() {
    this.soundEffects.playQueueResolve(SoundUtils.soundBank.worldMapIntro.id).then(() => {
      console.log("audio ended");
    });
  }

  testNotification() {
    this.localNotifications.notify("Test", "test", true, null);
  }

  testNotificationWithVibration() {
    this.localNotifications.notify("Test", "test", true, null);
    this.soundManager.vibrateContext(true);
  }

  testNotificationDelay() {
    setTimeout(() => {
      this.localNotifications.notify("Test", "test", true, null);
      this.soundManager.vibrateContext(true);
    }, 10000);
  }

  testUpdateModal() {

    let modalParams: IUpdatingAppNavParms = {
      title: "LP Update",
      infoHTML: "",
      statusObservable: null,
      progressObservable: null
    };

    let navParams: INavParams = {
      view: {
        fullScreen: false,
        transparent: false,
        large: true,
        addToStack: false,
        frame: false
      },
      params: modalParams
    };

    // not added to stack = cannot dismiss
    this.uiext.showCustomModal(null, UpdatingAppViewComponent, navParams).then(() => {
      console.log("returned from update app modal");
    }).catch((err: Error) => {
      console.error(err);
    });

  }

  toggleKboard() {
    console.log("is keyboard visible: ", this.keyboard.isVisible);
    // this.keyboard.show();

    if (!this.keyboard.isVisible) {
      this.keyboard.show();
    } else {
      this.keyboard.hide();
    }
  }

  diagnosticPermissionsSelfTest() {
    this.permissions.selfTest();
  }


  showToast() {
    this.uiext.showToastNoAction("Test", true, 100000);
  }

  /**
   * check new achievements
   * that have not been seen by the user yet
   */
  checkNewAchievements() {
    this.achievements.checkNewAchievements(true).then((medals: IGameItem[]) => {
      if (medals && medals.length > 0) {
        this.handleAchievementsUnlocked(medals);
      }
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  openLogin() {
    this.uiext.showCustomModal(null, LoginPage, {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      params: null
    }).then((_res: number) => {

    }).catch((err: Error) => {
      console.error(err);
    });
  }

  testZoomMeeting() {
    this.zoomService.initCore().then(() => {
      this.zoomService.connectWizard(null, null).then(() => {

      }).catch((err: Error) => {
        console.warn("connect error");
        console.error(err);
      });
    }).catch((err: Error) => {
      console.warn("init error");
      console.error(err);
    });
  }

  /**
   * handle achievements unlocked
   * notify only, no promise
   */
  handleAchievementsUnlocked(items: IGameItem[]) {
    let achievementUnlockedParams: IShareMsgParams = {
      xp: 10,
      newAchievements: {
        items: items,
        categoryName: "new achievements"
      },
      actionButtons: {
        watchAd: false,
        scanQR: false,
        share: false
      }
    };

    this.uiext.showCustomModal(null, AchievementUnlockedViewComponent, {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      params: achievementUnlockedParams
    }).then((res: number) => {
      switch (res) {
        case EAchievementUnlockedParams.viewMedals:
          GeneralCache.inventorySelectedCategory = EItemCategoryCodes.medals;
          let params: IInventoryNavParams = {
            closeOnItemUse: false,
            fixedCategory: false
          };

          this.uiext.showCustomModal(null, InventoryHomePage, {
            view: {
              fullScreen: true,
              transparent: false,
              large: true,
              addToStack: false,
              frame: false
            },
            params: params
          }).then(() => {

          }).catch((err: Error) => {
            console.error(err);
          });
          break;
        default:
          break;
      }
    }).catch((err: Error) => {
      console.error(err);
    });
  }


  testPhoto() {
    let params: IPhotoValidatorParams = {
      enable: true,
      intro: true,
      mode: EPhotoValidatorModes.compareDual,
      compareSelfTest: true,
      objects: []
    };

    console.log(params);
    // this.photoValidator.checkPhotoActivity(null, null, params).then((data) => {
    //     console.log(data);
    // }).catch((err: Error) => {
    //     console.error(err);
    // });

    let res: IPhotoResultResponse = {
      valid: true,
      alreadyUploaded: false,
      heading: null,
      message: "<p>Photo found message</p>",
      processedImageData: "https://leplace-storage.s3.eu-central-1.amazonaws.com/activities/snapshot_v2.jpg",
      uploadedPhotoUrl: "https://leplace-storage.s3.eu-central-1.amazonaws.com/activities/snapshot_v2.jpg"
    };

    this.photoValidator.showPhotoValidateResult(null, res).then((data) => {
      console.log(data);
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  testLoadGoogleImageUrl() {
    let url: string = "https://maps.googleapis.com/maps/api/place/js/PhotoService.GetPhoto?1sCmRaAAAAOlYJOAe0SwjA59HQhmRijdQm3q9qcfLmw6IauQQPcbvR6H6KGNR7Gnzr1z8_BClzuUpJ60Q44buH50Q2XMdBRGnaEMlR9_ZsdhxCekPwUHqUto5bEGQ-qM47KXb6YUWrEhAP24bWVXf7VVwwCCCZRpaVGhSIr_wZWbgGdhQo8H9yU0CKEEvgPQ&3u800&4u800&5m1&2e1&callback=none&key=AIzaSyAtvlCF2IjbHkB-ej1LDx6YlEmbiZVHn8U&token=76787";
    this.locationUtilsGooglePlus.getGoogleRedirectPhotoUrl(null, url).then((res: ILocationPhotoResult) => {
      console.log("get google redirect photo url: ", res);
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  openChatWithOperator() {
    this.mqttChatService.openChatWithOperator();
  }

  showProminentDisclosure() {
    let params: IDescriptionFrameParams = {
      loaderCode: ETutorialEntries.prominentDisclosure,
      fromCache: false,
      title: "Allow in-app location services",
      description: null,
      mode: EDescriptionViewStyle.withOk,
      photoUrl: null
    };

    return this.tutorials.showTutorialResolve("Allow in-app location services", ETutorialEntries.prominentDisclosure, null, params, false);
  }

  getImageB64() {

    let testUrl: string = 'https://s3.eu-central-1.amazonaws.com/leplace-storage/profiles/photo_25_1563014285271.jpg';
    // let testUrl: string = "https://approvaltests.com/images/logo.png";
    let img = new Image();

    // img.crossOrigin = "anonymous";

    img.src = testUrl;

    img.onload = (data) => {
      console.log("img loaded: ", data);
    };
    img.onerror = (err) => {
      console.error(err);
    };

    // this.imageLoaderTS.getImageB64(testUrl)
    this.imageLoaderTS.preload(testUrl).then((val) => {
      console.log("get image b64: " + val);
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  testAsyncAwait1() {
    let promise = new Promise((resolve) => {
      setTimeout(() => {
        this.testAA = 1;
        resolve(100);
      }, 2000);
    });
    return promise;
  }

  async testAsyncAwait2() {
    let promise = new Promise((resolve) => {
      setTimeout(() => {
        this.testAA = 2;
        resolve(100);
      }, 2000);
    });
    return promise;
  }

  async testAsyncAwait() {
    console.log("test async await");
    let a = await this.testAsyncAwait1();
    console.log(a, this.testAA);
    let b = await this.testAsyncAwait2();
    console.log(b, this.testAA);
  }

  showLoading() {
    let fn = async () => {
      await this.uiext.showLoadingV2Queue("Loading..");
      await SleepUtils.sleep(1000);
      await this.uiext.showLoadingV2Queue("Loading (2)..");
      await SleepUtils.sleep(1000);
      await this.uiext.showLoadingV2Queue("Loading (3)..");
      await SleepUtils.sleep(1000);
      await this.uiext.dismissLoadingV2();
    };
    fn();
  }

  testPhoto2() {
    this.photoViewer.viewPhoto("https://leplace-storage.s3.eu-central-1.amazonaws.com/activities/snapshot_v2.jpg",
      "AR Screenshot", {
      share: true,
      customModal: false,
      isDataUrl: false,
      changePhotoCallback: null
    });
  }

  testActivityParams() {
    let params: IActivityParamsView = {
      customParams: [],
      customParamsNav: [],
      mode: EActivityParamsViewModes.before,
      scope: ECustomParamScope.challenge,
      questData: null,
      videoGuideSpecs: null
    };

    this.uiext.showCustomModal(null, ActivityParamsViewComponent, {
      view: {
        fullScreen: false,
        transparent: false,
        large: false,
        addToStack: true,
        frame: false
      },
      params: params
    }).then(() => {

    }).catch((err: Error) => {
      console.error(err);
    });
  }

  testScreenshot() {
    this.screenshot.captureScreenshot("Test Screenshot", null, false).then(() => {

    }).catch((err: Error) => {
      console.error(err);
    });
  }

  testEditImage() {
    let testUrl: string = 'https://s3.eu-central-1.amazonaws.com/leplace-storage/profiles/photo_25_1563014285271.jpg';
    this.imageLoaderTS.preload(testUrl).then((val) => {
      let params: IImageCropFrameNavParams = {
        description: "test",
        title: "Test",
        photoUrl: val,
        quality: 60
      };
      this.uiext.showCustomModal(null, ImageCropFrameViewComponent, {
        view: {
          fullScreen: true,
          transparent: false,
          large: true,
          addToStack: true,
          frame: true
        },
        params: params
      }).then((res: string) => {
        console.log("crop result: " + res);
        this.mediaUtils.resizeImage(res, null, true).then((resizedB64: string) => {
          console.log("resize result: " + resizedB64);
        }).catch((err: Error) => {
          console.error(err);
        });
      }).catch((err: Error) => {
        console.error(err);
      });
    }).catch((err: Error) => {
      console.error(err);
    });
  }


  testActivityFailedPopup() {
    let params: IActivityFailed = {
      infoHTML: "<p>Time's up</p><p>You may try again in story mode</p><p>Watch for the timer</p>",
      retryEnabled: false,
      reasonCode: EStandardActivityFailedCode.timeExpired,
      shareMessage: null,
      xpScaleFactor: null
    };
    this.uiext.showCustomModal(null, ActivityFailedViewComponent, {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      params: params
    }).then(() => {

    }).catch((err: Error) => {
      console.error(err);

    });
  }

  async testSliderTutorial() {
    try {
      let slideData: IGenericSlideData[] = await this.storyData.getSliderTutorial(282);
      let res: number = await this.modularViews.showGameplayOverviewSlider(slideData, null);
    } catch (err) {
      console.error(err);
    }
  }

  testActivityFinishedPopup() {
    let activityStats: IActivityStatsContainer = this.activityStats.getExploreStats();
    for (let i = 0; i < activityStats.statsList.length; i++) {
      activityStats.statsList[i].value = Math.random() * 10;
    }
    activityStats.statsList[0].value = 10;
    // console.log(activityStats);
    let shareParams: IShareMsgParams = {
      place: {
        name: "test location",
        place: {
          db: null,
          ext: null,
          extLoaded: true,
          dispPhoto: null,
          index: null,
          merged: {
            name: "test",
            heading: "heading",
            url: null,
            id: 1,
            locationId: 1,
            googleId: "",
            photoUrl: "",
            type: "park",
            flag: 0,
            done: EStoryLocationDoneFlag.done,
            dynamic: 0,
            lat: null,
            lng: null,
            providerCode: null,
            rating: null,
            locationType: null,
            samePlace: null,
            activity: {
              name: "test",
              title: "test",
              hiddenPlace: 0,
              description: "test",
              finishedDescription: "",
              objectDescription: "",
              hasCustomParams: 1,
              gameContextCode: EGameContext.all,
              code: EActivityCodes.photo,
              paramsList: [],
              customParams: [
                {
                  code: 100001,
                  customParamCategoryCode: 1,
                  categoryName: "",
                  items: [],
                  customParamCategory: null,
                  description: "<p>Take a photo with a bike</p>",
                  // enabled: 1,
                  // id: 1,
                  // level: null,
                  // mode: null,
                  name: "Bicycle",
                  photoUrl: "https://leplace-storage.s3.eu-central-1.amazonaws.com/challenges/photo/bike_photo.jpg",
                  wikiUrl: null,
                  tag: "bicycle",
                  treasureSpec: null,
                  // treasureSpecCode: null,
                  value: null,
                }
              ],
              icon: "",
              photo: 0,
              photoUrl: "",
              similarCode: null,
              similar: null,
              photoValidate: 1,
              params: null,
              scan: 0
            }
          }
        }
      },
      story: {
        name: "test story",
        id: 0,
        rewardCoins: 10,
        worldMap: false
      },
      xp: 10,
      activityStats: {
        photoUrl: null,
        videoUrl: null,
        baseCode: EActivityCodes.photo,
        code: EActivityCodes.photo,
        finishedDescription: "",
        name: "",
        standardRewardCap: 10,
        progress: {
          target: [8.654687, 10],
          current: [9.852, 10]
        },
        statsList: activityStats.statsList
      },
      activityFinish: null,
      items: {
        collected: 20,
        collectedValue: 200,
        reward: 10,
        value: 1
      },
      actionButtons: {
        watchAd: true,
        scanQR: true,
        share: true
      }
    };

    this.uiext.showCustomModal(null, ActivityFinishedViewComponent, {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      params: shareParams
    }).then(() => {

    }).catch((err: Error) => {
      console.error(err);

    });
  }

  startDance() {
    this.dance.startMonitor();
  }

  stopDance() {
    this.dance.stopMonitor();
  }

  startDBMeter() {
    this.dbm.startMonitor();
  }

  stopDBMeter() {
    this.dbm.stopMonitor();
  }


  showAR() {
    let navParams: INavParams = {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: false,
        frame: false
      },
      params: null
    };

    this.uiext.showCustomModal(null, ARViewEntryPage, navParams).then((res: any) => {
      console.log("returned from ar view");
      console.log(res);
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  showStoryModal() {
    let params: IStoryListNavParams = {
      storyId: null,
      dynamic: false,
      reload: true,
      localStories: false,
      includeGlobal: true,
      category: null,
      categoryCode: null,
      selectedCityId: null,
      mapStyle: null,
      loadStory: false
    };

    this.uiext.showCustomModal(null, StoryCategoriesPage, {
      view: {
        fullScreen: false,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      params: params
    }).then(() => {
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  openGmapTestMode() {
    let params: IGmapEntryNavParams = {
      mode: EGmapMode.blank,
      storyNavParams: null
    };

    let navParams: INavParams = {
      view: null,
      params: params
    };

    this.nps.set(ENavParamsResources.gmap, navParams);

    this.router.navigate([ERouteDef.gmap], { replaceUrl: true }).then(() => {
    }).catch((err: Error) => {
      console.error(err);
    });
  }


  editContent() {
    let params: ITextInputParams = {
      description: "",
      text: "init description",
      title: "Edit content",
      focused: false,
      allowEmpty: true
    };

    this.uiext.showCustomModal(null, TextInputViewComponent, {
      view: {
        fullScreen: false,
        transparent: false,
        large: true,
        addToStack: true,
        frame: false
      },
      params: params
    }).then((description: ITextInputResult) => {
      console.log(description);
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  selectVoiceApp() {
    this.tts.getTTSVoiceOptionsApp("en-US").then((res: ITTSVoice[]) => {
      console.log(res);
    });
  }

  selectVoiceContent() {
    this.tts.getTTSVoiceOptionsContent("en-US").then((res: ITTSVoice[]) => {
      console.log(res);
    });
  }

  testTTS() {

    this.tts.textToSpeechNoAction("Welcome to world map! Please wait for the treasures to load", null, null, null);
  }

  testTTSQueue() {
    this.soundManager.ttsWrapper("Welcome to world map! Please wait for the treasures to load", true);
    // this.tts.textToSpeechQueue("Welcome to world map! Please wait for the treasures to load");
  }

  testTTSQueueCloud() {
    let content: string = "Welcome to world map! Please wait for the treasures to load";
    this.tts.textToSpeechQueue(content, false, 1, () => {
      console.log("tts queue finished");
    }, 120000, true);
  }


  showArenaModal(meetingPlaceMode: boolean) {

    let params: IArenaNavParams = {
      place: null,
      group: null,
      groupId: !meetingPlaceMode ? 24 : null,
      meetingPlace: null,
      meetingPlaceId: meetingPlaceMode ? 83758 : null,
      testing: true,
      chatOnly: false,
      groupRole: null,
      playerId: null,
      inRange: true,
      canExit: true,
      enableGroups: true,
      isStoryline: false,
      isLobbyContext: null,
      context: EGroupContext.global,
      contextId: null,
      synchronized: true
    };
    this.uiext.showCustomModal(null, MPHomePage, {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      params: params
    }).then(() => {
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  showSignupTerms() {
    this.tutorials.showSignupTermsNoAction(true);
  }

  showSignupTutorial() {
    this.tutorials.showSignupTutorialNoAction();
  }

  testVideo() {
    // this.ytp.open('ELLRcPjMR5o', null);
    this.ytp.openIframe(null, 'https://www.youtube.com/embed/0jIeAQJubBc', "Video Tutorial", false);
  }

  testAlert() {
    this.uiext.showAlertNoAction("test title", "<p>test content</p><p>test content</p>");
  }

  showMPLeaderboard() {
    let res: IMPGameResultPlayer[] = [];
    res.push({
      playerId: 1,
      score: 100,
      position: 1,
      verdict: EMPGameResultVerdict.finished,
      activityDetails: {
        coinsCollected: 10,
        totalDistance: 10
      }
    });

    res.push({
      playerId: 25,
      score: 80,
      position: 2,
      verdict: EMPGameResultVerdict.finished,
      activityDetails: {
        coinsCollected: 5,
        totalDistance: 10
      }
    });

    res.push({
      playerId: 4,
      score: 60,
      position: 0,
      verdict: EMPGameResultVerdict.failed,
      activityDetails: null
    });


    res.push({
      playerId: 3,
      score: 60,
      position: 0,
      verdict: EMPGameResultVerdict.failed,
      activityDetails: null
    });

    let elb: IEventLeaderboard = null;
    let groupMembers: IGroupMember[] = [];

    groupMembers.push({
      id: 2,
      userId: 25,
      groupId: 1,
      type: 2,
      timestamp: null,
      user: {
        id: 25,
        name: "user25",
        alias: "user25",
        timestamp: null,
        loginTimestamp: null,
        photoUrl: null,
        cachedCoins: 10,
        cachedDistance: 20,
        cachedLevel: 1,
        cachedScore: 0,
        rank: 0,
        settings: null,
        stats: null,
        tutorialSeen: 1,
        countryCode: null
      }
    });

    groupMembers.push({
      id: 1,
      userId: 1,
      groupId: 1,
      type: 1,
      timestamp: null,
      user: {
        id: 1,
        name: "user1",
        alias: "user1",
        timestamp: null,
        loginTimestamp: null,
        photoUrl: "https://s3.eu-central-1.amazonaws.com/leplace-storage/profiles/photo_25_1560612760062.jpg",
        cachedCoins: 10,
        cachedDistance: 20,
        cachedLevel: 1,
        cachedScore: 0,
        rank: 0,
        settings: null,
        stats: null,
        tutorialSeen: 1,
        countryCode: null
      }
    });



    groupMembers.push({
      id: 4,
      userId: 4,
      groupId: 1,
      type: 1,
      timestamp: null,
      user: {
        id: 4,
        name: "user4",
        alias: "user4",
        timestamp: null,
        loginTimestamp: null,
        photoUrl: null,
        cachedCoins: 10,
        cachedDistance: 20,
        cachedLevel: 1,
        cachedScore: 0,
        rank: 0,
        settings: null,
        stats: null,
        tutorialSeen: 1,
        countryCode: null
      }
    });

    groupMembers.push({
      id: 3,
      userId: 3,
      groupId: 1,
      type: 1,
      timestamp: null,
      user: {
        id: 3,
        name: "user3",
        alias: "user3",
        timestamp: null,
        loginTimestamp: null,
        photoUrl: null,
        cachedCoins: 10,
        cachedDistance: 20,
        cachedLevel: 1,
        cachedScore: 0,
        rank: 0,
        settings: null,
        stats: null,
        tutorialSeen: 1,
        countryCode: null
      }
    });


    elb = {
      id: null,
      eventId: null,
      leaderboardId: null,
      timestamp: null,
      leaderboard: {
        id: null,
        name: null,
        description: null,
        timestamp: null,
        players: []
      }
    };

    let gameResults: IMPGameResults = {
      items: res,
      duration: 300,
      groupId: null,
      challengeId: null
    };

    this.mpGameInterface.formatLeaderboard(elb, gameResults);
    groupMembers = this.mpGameInterface.combineUserStaticData(groupMembers, res);
    elb.leaderboard.players = groupMembers.map(gm => gm.user);

    let params: ILeaderboardNavParams = {
      reload: false,
      scope: ELeaderboardScope.event,
      lb: elb,
      mpCard: true,
      eventListNavParams: null
    };

    this.uiext.showCustomModal(null, LeaderboardPage, {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: false,
        frame: false
      },
      params: params
    }).then(() => {
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  testMessageQ(priority: boolean) {
    let msg: string = "test " + new Date().getTime();
    if (priority) {
      msg += " priority";
    }
    this.messageQ.prepare(msg, priority, EQueueMessageCode.info);
  }

  testStoryFinishedPopup(finished: boolean) {
    let shareParams: IShareMsgParams = {
      photo: {
        display: "https://s3.eu-central-1.amazonaws.com/leplace-storage/stories/generic/explore.jpg",
        share: null,
      },
      place: {
        name: "test location"
      },
      xp: 10,
      story: {
        worldMap: false,
        name: "test story",
        id: 366,
        rewardCoins: 10,
        progress: {
          finished: true,
          percentFinished: 100,
          alreadyFinished: false
        },
        story: {
          id: 366
        } as any
      },
      activityStats: {
        photoUrl: null,
        videoUrl: null,
        baseCode: EActivityCodes.run,
        code: EActivityCodes.run,
        finishedDescription: "",
        name: "",
        standardRewardCap: 10
      },
      items: {
        collected: 10,
        collectedValue: 10,
        reward: 0,
        value: 1
      },
      actionButtons: {
        watchAd: false,
        scanQR: false,
        share: false
      }
    };

    if (!finished) {
      shareParams.story.progress.finished = false;
      shareParams.story.progress.percentFinished = 25;
    }

    this.uiext.showCustomModal(null, StoryFinishedViewComponent, {
      view: {
        fullScreen: true,
        transparent: false,
        large: true,
        addToStack: true,
        frame: true
      },
      params: shareParams
    }).then(() => {

    }).catch((err: Error) => {
      console.error(err);

    });
  }


  clearWatch() {
    this.subscription = ResourceManager.clearSubObj(this.subscription);
    this.timeouts = ResourceManager.clearTimeoutObj(this.timeouts);
  }

  testBeaconScanner() {
    // if (!this.indoorLocation.isScannerRunning()) {
    //   this.indoorLocation.startWizard();
    // } else {
    //   this.indoorLocation.stopWizard();
    // }

    let params: IBeaconScannerParams = {
      title: "Beacon Scanner",
      description: null
    };

    this.uiext.showCustomModal(null, BeaconScannerViewComponent, {
      view: {
        fullScreen: false,
        transparent: false,
        large: true,
        addToStack: true,
        frame: false
      },
      params: params
    }).then(() => {

    }).catch((err: Error) => {
      console.error(err);
    });
  }

}

